const data = [
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditi Samantaray",
    "orank": 134,
    "prize": "School Bronze Medal",
    "roll": "AM196801347",
    "school": "DAV Public School, Unit 8",
    "score": "25/40",
    "srank": 3
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Narayan Pany",
    "orank": 268,
    "prize": "",
    "roll": "AM196801707",
    "school": "Sai International school",
    "score": "19 / 40",
    "srank": 10
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyasha Priyadarsini Mohalik",
    "orank": 133,
    "prize": "School Silver Medal",
    "roll": "AM196801703",
    "school": "DAV public school",
    "score": "26 / 40",
    "srank": 2
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aishani nanda",
    "orank": 125,
    "prize": "School Gold Medal",
    "roll": "AM196801200",
    "school": "DAV Public School Cspur",
    "score": "29 / 40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Akshat Bhadra",
    "orank": 65,
    "prize": "School Gold Medal",
    "roll": "AM196801407",
    "school": "DAV Public School Cspur",
    "score": "33/40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anshika Swain",
    "orank": "",
    "prize": "",
    "roll": "AM196801308",
    "school": "Lumbini Public School",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesh Mohapatra ",
    "orank": 79,
    "prize": "School Gold Medal",
    "roll": "AM196801391",
    "school": "Cohen International",
    "score": "32/40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Arshita Mahapatra",
    "orank": 42,
    "prize": "School Gold Medal + Special prize",
    "roll": "AM196801049",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "35/40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ashutosh Sahoo",
    "orank": 189,
    "prize": "",
    "roll": "AM196801708",
    "school": "ODM Public School",
    "score": "20 / 40",
    "srank": 7
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bindu Jena",
    "orank": 133,
    "prize": "School Silver Medal",
    "roll": "AM196801399",
    "school": "Saraswati Sishu Mandir, Niladrivihar",
    "score": "26/40",
    "srank": 2
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Debansh Nayak",
    "orank": 172,
    "prize": "",
    "roll": "AM196810395",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "21/40",
    "srank": 6
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Divyansh Rout",
    "orank": 35,
    "prize": "School Gold Medal + Special prize",
    "roll": "AM196801340",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "37/40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jashasa Pattnaik",
    "orank": 130,
    "prize": "School Silver Medal",
    "roll": "AM196801503",
    "school": "Lumbini Public School",
    "score": "28/40",
    "srank": 2
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Kamya Sharma",
    "orank": 125,
    "prize": "School Gold Medal",
    "roll": "AM196801704",
    "school": "ODM Public School",
    "score": "29 / 40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Krish Pradhani",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196801206",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "40/40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Kritika Bal",
    "orank": 158,
    "prize": "",
    "roll": "AM196801349",
    "school": "Lumbini Public School",
    "score": "23/40",
    "srank": 5
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Maheshi Naik",
    "orank": 189,
    "prize": "",
    "roll": "AM196801351",
    "school": "Lumbini Public School",
    "score": "20/40",
    "srank": 7
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Manimelina Patra",
    "orank": 132,
    "prize": "Cash award of Rs.1500/- (Prize shared) Olympiad Silver Medal ",
    "roll": "AM196801355",
    "school": "DAV CSPur",
    "score": "27/40",
    "srank": 2
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Mimansa Mishra",
    "orank": 147,
    "prize": "",
    "roll": "AM196810325",
    "school": "Kendriya Vidyalaya No.1 Bhubaneswar 1st shift",
    "score": "24 / 40",
    "srank": 4
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Mrunal Behera",
    "orank": 99,
    "prize": "School Gold Medal",
    "roll": "AM196801504",
    "school": "DAV Public School, Garage Chhak",
    "score": " 30/40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Prithwi Yuvraj Kanungo",
    "orank": "",
    "prize": "",
    "roll": "AM196801346",
    "school": "KENDRIYA VIDYALAYA NO-1 (2ND SHIFT ) BHUBANESWAR",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai swastik Ojha",
    "orank": 134,
    "prize": "School Bronze Medal",
    "roll": "AM196801348",
    "school": "Lumbini Public School",
    "score": "25/40",
    "srank": 3
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sanhita Dash",
    "orank": 125,
    "prize": "School Gold Medal",
    "roll": "AM196801350",
    "school": "Omm Gurukul Public School, BBSR",
    "score": "29/40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Snehalin Swain",
    "orank": 158,
    "prize": "",
    "roll": "AM196801047",
    "school": "Lumbini Public School",
    "score": "23/40",
    "srank": 5
  },
  {
    "class": "1",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aditya Narayan Pany",
    "orank": 254,
    "prize": "",
    "roll": "AR196801402",
    "school": "Sai International school",
    "score": "19 / 50",
    "srank": 9
  },
  {
    "class": "1",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Adyasha Priyadarsini Mohalik",
    "orank": 111,
    "prize": "",
    "roll": "AR196801398",
    "school": "DAV public school",
    "score": "26 / 50",
    "srank": 4
  },
  {
    "class": "1",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ashutosh Sahoo",
    "orank": 189,
    "prize": "",
    "roll": "AR196801403",
    "school": "ODM Public School",
    "score": "20 / 40",
    "srank": 8
  },
  {
    "class": "1",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Kamya Sharma",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196801399",
    "school": "ODM Public School",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Tripathy Divyajyoti Senapati",
    "orank": 45,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196801378",
    "school": "Mount Litra Zee School",
    "score": "35/40",
    "srank": 2
  },
  {
    "class": "1",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Vaibhav Raj",
    "orank": 96,
    "prize": "School Bronze Medal",
    "roll": "AR196801389",
    "school": "Mount Litra Zee School",
    "score": "30/40",
    "srank": 3
  },
  {
    "class": "1",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Vaishnavi Mohapatra",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196801302",
    "school": "Mount Litra Zee School",
    "score": "40/40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aditya Narayan Pany",
    "orank": 298,
    "prize": "",
    "roll": "AS196801136",
    "school": "Sai International school",
    "score": "19 / 50",
    "srank": 12
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Adyasha Priyadarsini Mohalik",
    "orank": 201,
    "prize": "",
    "roll": "AS196801132",
    "school": "DAV public school",
    "score": "26 / 50",
    "srank": 7
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ashutosh Sahoo",
    "orank": 289,
    "prize": "",
    "roll": "AS196801137",
    "school": "ODM Public School",
    "score": "20 / 40",
    "srank": 11
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Kamya Sharma",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196801133",
    "school": "ODM Public School",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Kritika Bal",
    "orank": 254,
    "prize": "",
    "roll": "AS196801208",
    "school": "Lumbini Public School",
    "score": "21/40",
    "srank": 10
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Maheshi Naik",
    "orank": 235,
    "prize": "",
    "roll": "AS196801210",
    "school": "Lumbini Public School",
    "score": "22/40",
    "srank": 9
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Mimansa Mishra",
    "orank": 98,
    "prize": "",
    "roll": "AS196810225",
    "school": "Kendriya Vidyalaya No.1 Bhubaneswar ",
    "score": "34 / 40",
    "srank": 5
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "ParasDeep Patnaik",
    "orank": 45,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196801332",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "37/40",
    "srank": 3
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Prithwi Yuvraj Kanungo",
    "orank": 23,
    "prize": "School Silver Medal + Special prize",
    "roll": "AS196801233",
    "school": "KENDRIYA VIDYALAYA NO-1 (2ND SHIFT ) BHUBANESWAR",
    "score": "38/40",
    "srank": 2
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai swastik Ojha",
    "orank": 201,
    "prize": "",
    "roll": "AS196801207",
    "school": "Lumbini Public School",
    "score": "26/40",
    "srank": 7
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sambhabana Panda",
    "orank": 152,
    "prize": "",
    "roll": "AS196801138",
    "school": "Mount Litra Zee School",
    "score": "31/40",
    "srank": 6
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Samyak Sekhar Rout",
    "orank": 78,
    "prize": "",
    "roll": "AS196801139",
    "school": "Cohen International",
    "score": "35/4",
    "srank": 4
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sanhita Dash",
    "orank": 186,
    "prize": "School Gold Medal",
    "roll": "AS196801209",
    "school": "Omm Gurukul Public School, BBSR",
    "score": "30/35",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Snehalin Swain",
    "orank": 219,
    "prize": "",
    "roll": "AS196801206",
    "school": "Lumbini Public School",
    "score": "25/35",
    "srank": 8
  },
  {
    "class": "1",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Aditya Narayan Pany",
    "orank": 121,
    "prize": "School Bronze Medal",
    "roll": "AT196801401",
    "school": "Sai International school",
    "score": "29/40",
    "srank": 3
  },
  {
    "class": "1",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Ashutosh Sahoo",
    "orank": 231,
    "prize": "",
    "roll": "AT196801402",
    "school": "ODM Public School",
    "score": "20 / 40",
    "srank": 4
  },
  {
    "class": "1",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Susri Sadhana Sahu",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AT196801301",
    "school": "Mount Litra Zee School",
    "score": "40/40",
    "srank": 1
  },
  {
    "class": "1",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Swastik Dash",
    "orank": 11,
    "prize": "School Silver Medal + Special prize",
    "roll": "AT196801302",
    "school": "Mount Litra Zee School",
    "score": "36/40",
    "srank": 2
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aadrashree Routray",
    "orank": 165,
    "prize": "School Gold Medal",
    "roll": "AM196810427",
    "school": "St. Xavier high School, Satyanagar",
    "score": "45/60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Abhijeet Dutta",
    "orank": 132,
    "prize": "",
    "roll": "AM196810428",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "48/60",
    "srank": 8
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adarsh Das",
    "orank": 17,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196810597",
    "school": "Cohen International",
    "score": "59/60",
    "srank": 2
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Bhuyan",
    "orank": 32,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196810600",
    "school": "DAV Public School, Unit 11",
    "score": "57/60",
    "srank": 3
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Narayan Sahu",
    "orank": 123,
    "prize": "",
    "roll": "AM196810605",
    "school": "Lumbini Public School",
    "score": "49/60",
    "srank": 8
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyashree Garnayak",
    "orank": 101,
    "prize": "",
    "roll": "AM196810606",
    "school": "Kendriya vidyalaya no. 1, bbsr",
    "score": "50/60",
    "srank": 7
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amlan Aryan",
    "orank": 165,
    "prize": "",
    "roll": "AT196810327",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "45/60",
    "srank": 10
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amritanshu Tripathy",
    "orank": 75,
    "prize": "",
    "roll": "AM196810610",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "51/60",
    "srank": 6
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Annika Mohanty",
    "orank": 284,
    "prize": "",
    "roll": "AM196810608",
    "school": "Lumbini Public School",
    "score": "32/60",
    "srank": 16
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anshika Swain",
    "orank": 292,
    "prize": "",
    "roll": "AM196807605",
    "school": "DAV PUBLIC SCHOOL , CHANDRASEKHARPUR",
    "score": "31 / 60",
    "srank": 17
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesha Sar ",
    "orank": 54,
    "prize": "",
    "roll": "AM196810609",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "55/60",
    "srank": 4
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Archit Pasayat ",
    "orank": 68,
    "prize": "",
    "roll": "AM196810611",
    "school": "St. Xaviers Dist. Centre",
    "score": "53/60",
    "srank": 5
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Arpit Arman Nayak",
    "orank": 165,
    "prize": "",
    "roll": "AM196810612",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "45/60",
    "srank": 10
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Atulith Behera",
    "orank": 54,
    "prize": "",
    "roll": "AR196810113",
    "school": "Kendriya vidyalaya no.1 bbsr",
    "score": "55/60",
    "srank": 4
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ayaansh Samal",
    "orank": 231,
    "prize": "",
    "roll": "AM196810327",
    "school": "Bal Bharati Public School",
    "score": "37/6",
    "srank": 12
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dharashree Naik",
    "orank": 224,
    "prize": "",
    "roll": "AM196807427",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "38 / 60",
    "srank": 11
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Divyanshi Rath",
    "orank": "",
    "prize": "",
    "roll": "AM196807606",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "LALKRISHNA MISHRA",
    "orank": "",
    "prize": "",
    "roll": "AM196807597",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Lanibandash",
    "orank": "",
    "prize": "",
    "roll": "AM196807611",
    "school": "Kv 1 bbsr 2nd shift",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Nikhil Kumar Das",
    "orank": 256,
    "prize": "",
    "roll": "AM196807607",
    "school": "DAV Public School, Chandrasekharpur, BBSR-21",
    "score": "35 / 60",
    "srank": 15
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Nirali Nirliprta Sahoo",
    "orank": 401,
    "prize": "",
    "roll": "AM196807612",
    "school": "Kv 1 bbsr 2nd shift",
    "score": "Oct-60",
    "srank": 19
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Noorul Abideen",
    "orank": 245,
    "prize": "",
    "roll": "AM196810113",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "36 / 60",
    "srank": 13
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Priyanka Priyadashini Rout",
    "orank": 101,
    "prize": "",
    "roll": "AM196807600",
    "school": "Kendriya vidyalaya no 1 bhubaneswar",
    "score": "50 / 60",
    "srank": 7
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ritika Rani Patra ",
    "orank": 231,
    "prize": "",
    "roll": "AM196807428",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "37 / 60",
    "srank": 12
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai Krishna Swain",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196810425",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "60 / 60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Satwik Samarpan",
    "orank": 301,
    "prize": "",
    "roll": "AM196807609",
    "school": "DAV public School , Cspur ,bbsr",
    "score": "27 / 60",
    "srank": 18
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shashwat Dharma Sabat",
    "orank": 101,
    "prize": "School Gold Medal",
    "roll": "AM196810097",
    "school": "Kendriya Vidyalaya No. 1, Bhubaneswar",
    "score": "50/60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Vedanshi Behera",
    "orank": 256,
    "prize": "",
    "roll": "AM196807608",
    "school": "DAV public School , Cspur ,bbsr",
    "score": "35 / 60",
    "srank": 14
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ayushman Swain",
    "orank": 136,
    "prize": "",
    "roll": "AT196810157",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "37/60",
    "srank": 10
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Baisakhi Mohanty",
    "orank": 523,
    "prize": "",
    "roll": "AR196807765",
    "school": "KENDRIYA VIDYALAYA NO-1",
    "score": "Nov-60",
    "srank": 25
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Basudev Sahu",
    "orank": 101,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196810412",
    "school": "KENDRIYA VIDYALAYA NO-1",
    "score": "42/60",
    "srank": 6
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Bhumika ",
    "orank": 112,
    "prize": "",
    "roll": "AR196810414",
    "school": "DAV PUBLIC SCHOOL CHANDRASEKHARPUR",
    "score": "41/60",
    "srank": 7
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Choudhury Satyak Nanda",
    "orank": 115,
    "prize": "",
    "roll": "AR196810415",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "40/60",
    "srank": 8
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Dharashree Naik",
    "orank": 128,
    "prize": "",
    "roll": "AR196807414",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "38 / 60",
    "srank": 9
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Dibyansha Sahoo",
    "orank": 45,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196810761",
    "school": "K.V. no- 1,(1st shift) BBSR",
    "score": "51/60",
    "srank": 3
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Divyalaxmi Swain ",
    "orank": 64,
    "prize": "",
    "roll": "AR196810762",
    "school": "DAV public School Chandrasekharpur",
    "score": "48/60",
    "srank": 4
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Janmay Sahu",
    "orank": 36,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196810765",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "52/60",
    "srank": 2
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Kalpita Patra",
    "orank": 98,
    "prize": "",
    "roll": "AR196810767",
    "school": "Kendriya Vidyalaya no. 4",
    "score": "45/60",
    "srank": 5
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Krishna Kripal Raja",
    "orank": 29,
    "prize": "School Gold Medal + Special prize",
    "roll": "AR196810768",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "58/60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Lalkrishna Mishra",
    "orank": 389,
    "prize": "",
    "roll": "AR196807762",
    "school": "Kendriya Vidyalaya NO-1 Bhubaneswar",
    "score": "20 / 60",
    "srank": 15
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Lanibandash",
    "orank": "",
    "prize": "",
    "roll": "AR196807768",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Manavi Padhi",
    "orank": "",
    "prize": "",
    "roll": "AR196810769",
    "school": "DAV CSPur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "MANNAT KUMAR SINHA",
    "orank": 423,
    "prize": "",
    "roll": "AR196807761",
    "school": "KV NO 1 BBSR",
    "score": "14 / 60",
    "srank": 21
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Meghana G",
    "orank": 156,
    "prize": "",
    "roll": "AR196807767",
    "school": "Narayana E-techno School",
    "score": "29 / 60",
    "srank": 11
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Nirali Nirliprta Sahoo",
    "orank": 469,
    "prize": "",
    "roll": "AR196807769",
    "school": "Kv no 1 bbsr-,2nd shift",
    "score": "Dec-60",
    "srank": 23
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ritika Rani Patra ",
    "orank": 136,
    "prize": "",
    "roll": "AR196807415",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "37 / 60",
    "srank": 10
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sai Krishna Swain",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196810412",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "60 / 60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Shashwat Dharma Sabat",
    "orank": 98,
    "prize": "School Gold Medal",
    "roll": "AR196810157",
    "school": "Kendriya Vidyalaya No. 1, Bhubaneswar",
    "score": "45/60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Amlan Aryan",
    "orank": "",
    "prize": "",
    "roll": "AS196810227",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Anshika Swain",
    "orank": 235,
    "prize": "",
    "roll": "AS196807619",
    "school": "DAV PUBLIC SCHOOL CHANDRASEKHARPUR , BHUBANESWAR - 21",
    "score": "29 / 60",
    "srank": 14
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Dharashree Naik",
    "orank": 156,
    "prize": "",
    "roll": "AS196807234",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "38 / 60",
    "srank": 9
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Divyanshi Rath",
    "orank": 201,
    "prize": "",
    "roll": "AS196807620",
    "school": "Dav public school, cspur, bbsr",
    "score": "33 / 60",
    "srank": 12
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Lalkrishna Mishra",
    "orank": 286,
    "prize": "",
    "roll": "AS196807611",
    "school": "Kendriya Vidyalaya NO-1 Bhubaneswar",
    "score": "25 / 60",
    "srank": 16
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Lanibandash",
    "orank": "",
    "prize": "",
    "roll": "AS196807622",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Mayank Khamari",
    "orank": "",
    "prize": "",
    "roll": "AM196810109",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Meghana G",
    "orank": 201,
    "prize": "",
    "roll": "AS196807617",
    "school": "Narayana E-techno School",
    "score": "33 / 60",
    "srank": 12
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Mokshita Das",
    "orank": 112,
    "prize": "",
    "roll": "AS196810232",
    "school": "DAV Public school chandrasekharpur BBSR Odisha",
    "score": "48/60",
    "srank": 6
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nikhil Kumar Das",
    "orank": 165,
    "prize": "",
    "roll": "AS196807621",
    "school": "DAV Public School, CSPUR, Bhubaneswar",
    "score": "37 / 60",
    "srank": 10
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nikhil Ranjan Dash",
    "orank": 95,
    "prize": "",
    "roll": "AS196810234",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "49/60",
    "srank": 5
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nirali Nirliprta Sahoo",
    "orank": 352,
    "prize": "",
    "roll": "AS196807623",
    "school": "Kv 1 bbsr 2nd shift",
    "score": "21 / 60",
    "srank": 17
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nisith Naman Parida",
    "orank": 91,
    "prize": "",
    "roll": "AS196810235",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "50/60",
    "srank": 4
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Noorul Abideen",
    "orank": 199,
    "prize": "",
    "roll": "AS196810229",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "36 / 60",
    "srank": 11
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Omm Swaroop Rout",
    "orank": 136,
    "prize": "",
    "roll": "AS196810611",
    "school": "Kendriya vidyalaya No-1 BBSR",
    "score": "45/60",
    "srank": 7
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Pratyamshu Moharana",
    "orank": 254,
    "prize": "",
    "roll": "AS196807616",
    "school": "Kendriya Vidyalaya No.1 BBSR,Odisha",
    "score": "27 / 60",
    "srank": 15
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Reetika Nath",
    "orank": 141,
    "prize": "",
    "roll": "AS196810616",
    "school": "Mount Litra Zee School",
    "score": "41/60",
    "srank": 8
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ritika Rani Patra ",
    "orank": 165,
    "prize": "",
    "roll": "AS196807235",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "37 / 60",
    "srank": 10
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai Krishna Swain",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196807232",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "60 / 60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Samikshya Ray",
    "orank": 65,
    "prize": "School Silver Medal",
    "roll": "AS196810617",
    "school": "Mount Litra Zee School",
    "score": "53/60",
    "srank": 2
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Satwik Samarpan",
    "orank": 220,
    "prize": "",
    "roll": "AS196807624",
    "school": "Satwik Samarpan",
    "score": "31 / 60",
    "srank": 13
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shashwat Dharma Sabat",
    "orank": 136,
    "prize": "School Gold Medal",
    "roll": "AS196810109",
    "school": "Kendriya Vidyalaya No. 1, Bhubaneswar",
    "score": "45/60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Suhani Nath",
    "orank": 75,
    "prize": "School Bronze Medal",
    "roll": "AS196810619",
    "school": "Mount Litra Zee School",
    "score": "51/60",
    "srank": 3
  },
  {
    "class": "10",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Suryanshu Sundar Subudhi",
    "orank": 59,
    "prize": "School Gold Medal",
    "roll": "AS196810620",
    "school": "Mount Litra Zee School",
    "score": "55/60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Dharashree Naik",
    "orank": 61,
    "prize": "School Bronze Medal",
    "roll": "SS196807101",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50 / 40",
    "srank": 3
  },
  {
    "class": "10",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Lanibandash",
    "orank": "",
    "prize": "",
    "roll": "SS196807154",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Shashwat Dharma Sabat",
    "orank": 89,
    "prize": "School Gold Medal",
    "roll": "SS196810098",
    "school": "Kendriya Vidyalaya No. 1, Bhubaneswar",
    "score": "51/60",
    "srank": 1
  },
  {
    "class": "10",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Varenya Mahala",
    "orank": 101,
    "prize": "School Silver Medal",
    "roll": "SS196810101",
    "school": "Mount Litra Zee School",
    "score": "50/60",
    "srank": 2
  },
  {
    "class": "10",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Vedanshi Behera",
    "orank": 145,
    "prize": "",
    "roll": "SS196810154",
    "school": "Mount Litra Zee School",
    "score": "45/6",
    "srank": 4
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Anshika Swain",
    "orank": 61,
    "prize": "",
    "roll": "AT196807725",
    "school": "DAV PUBLIC SCHOOL CHANDRASEKHARPUR",
    "score": "29 / 60",
    "srank": 8
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Dev Pradhani ",
    "orank": "",
    "prize": "",
    "roll": "AT196807726",
    "school": "St.Xavier High School, Satyanagar",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Dharashree Naik",
    "orank": 165,
    "prize": "School Silver Medal ",
    "roll": "AT196807636",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "38 / 60",
    "srank": 2
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Krish Pradhani",
    "orank": "",
    "prize": "",
    "roll": "AT196810534",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Lanibandash",
    "orank": "",
    "prize": "",
    "roll": "AT196807728",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Mannat kumar sinha",
    "orank": 356,
    "prize": "",
    "roll": "AT196807721",
    "school": "kv no 1 bbsr",
    "score": "21 / 60",
    "srank": 17
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Nikhil Kumar Das",
    "orank": 55,
    "prize": "",
    "roll": "AT196807727",
    "school": "DAV Public School, CSPUR, Bhubaneswar-21",
    "score": "31 / 60",
    "srank": 5
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Nikhil Kumar Das",
    "orank": "",
    "prize": "",
    "roll": "AR196807727",
    "school": "DAV Public School, CSPUR, Bhubaneswar-22",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Nirali Nirliprta Sahoo",
    "orank": 423,
    "prize": "",
    "roll": "AT196807729",
    "school": "Kv no 1 bbsr 2nd shift",
    "score": "Nov-60",
    "srank": 18
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Noorul Abideen",
    "orank": 52,
    "prize": "",
    "roll": "AT196810245",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "36 / 60",
    "srank": 4
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Omkarnath Pati",
    "orank": 86,
    "prize": "",
    "roll": "AT196807724",
    "school": "Kendriya Vidyalaya NO.1 Bhubaneswar 1st shift",
    "score": "27 / 60",
    "srank": 11
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Ritika Rani Patra ",
    "orank": 178,
    "prize": "School Bronze Medal",
    "roll": "AT196807637",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "37 / 60",
    "srank": 3
  },
  {
    "class": "10",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Shashwat Dharma Sabat",
    "orank": 121,
    "prize": "School Gold Medal",
    "roll": "AT196810127",
    "school": "Kendriya Vidyalaya No. 1, Bhubaneswar",
    "score": "46/60",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aahana Aditi Das",
    "orank": 156,
    "prize": "",
    "roll": "AM196802217",
    "school": "St. Xavier high School, Satyanagar",
    "score": "31/40",
    "srank": 9
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aaratrika Panda",
    "orank": 145,
    "prize": "",
    "roll": "AM196802228",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "32/40",
    "srank": 8
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aarush Nayak",
    "orank": 178,
    "prize": "",
    "roll": "AM196802667",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 40",
    "srank": 11
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aashvee Yashaswini Swain",
    "orank": 168,
    "prize": "",
    "roll": "AM196802554",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "30/40",
    "srank": 10
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Abhigyan Samal",
    "orank": 111,
    "prize": "",
    "roll": "AM196802215",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "34/40",
    "srank": 6
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Abhirup Tripathy",
    "orank": 178,
    "prize": "",
    "roll": "AM196802655",
    "school": "Cohen International",
    "score": "29/40",
    "srank": 11
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Abhishri Abhijita Pal",
    "orank": 102,
    "prize": "",
    "roll": "AS196802656",
    "school": "Cohen International",
    "score": "35/40",
    "srank": 5
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adhwika Kanungo",
    "orank": 324,
    "prize": "",
    "roll": "AM196802656",
    "school": "Lumbini Public School",
    "score": "18 / 40",
    "srank": 19
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Aryan Singh",
    "orank": 145,
    "prize": "",
    "roll": "AM196802651",
    "school": "DAV Public School, Unit 10",
    "score": "32/40",
    "srank": 8
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Mallick",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196802671",
    "school": "Lumbini Public School",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "ADITYA NARAYAN SWAIN",
    "orank": 221,
    "prize": "",
    "roll": "AM196802209",
    "school": "KENDRIYA VIDAYALAYA-1 BBSR",
    "score": "27 / 40",
    "srank": 13
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Advika Mohanty",
    "orank": 324,
    "prize": "",
    "roll": "AM196802216",
    "school": "D.A.V PUBLIC SCHOOL UNIT 8 BBSR",
    "score": "18 / 40",
    "srank": 19
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adya Utkalika Das",
    "orank": 125,
    "prize": "",
    "roll": "AM196802614",
    "school": "DAV Public school, CSPur",
    "score": "33/40",
    "srank": 7
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyaveer Sahu",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196802214",
    "school": "Kendriya vidyalaya no. 1, bbsr",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amritanshu Das",
    "orank": 285,
    "prize": "",
    "roll": "AM196802664",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "20 / 40",
    "srank": 17
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ankit Uthansingh",
    "orank": 301,
    "prize": "",
    "roll": "AM196802418",
    "school": "Lumbini Public School",
    "score": "19/40",
    "srank": 18
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anshul Nayak",
    "orank": 85,
    "prize": "",
    "roll": "AM196802425",
    "school": "Cohen International",
    "score": "36/40",
    "srank": 4
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesh Pradhan",
    "orank": 61,
    "prize": "School Bronze Medal",
    "roll": "AM196802426",
    "school": "Cohen International",
    "score": "37/40",
    "srank": 3
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Arush Mohanty",
    "orank": 45,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196802427",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "39/40",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ashmit Kumar Mishra",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196802220",
    "school": "DAV Chandrasekharpur",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ayushi Senapati",
    "orank": 197,
    "prize": "",
    "roll": "AM196808617",
    "school": "Kendriya Vidyalaya no.1 BBSR 1st Shift",
    "score": "28 / 40",
    "srank": 12
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bismit Sahoo",
    "orank": 178,
    "prize": "",
    "roll": "AM196802428",
    "school": "DAV PUBLIC SCHOOL UNIT-VIII BHUBANESWAR",
    "score": "29/40",
    "srank": 11
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Chhanda Madhuri sahu",
    "orank": 234,
    "prize": "",
    "roll": "AM196806326",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "26 / 40",
    "srank": 14
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Debanshi Parida",
    "orank": 267,
    "prize": "",
    "roll": "AM196802659",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "21 / 40",
    "srank": 16
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Deekshita Dhal",
    "orank": 125,
    "prize": "",
    "roll": "AM196802429",
    "school": "DAV PUBLIC SCHOOL UNIT - 8 BBSR",
    "score": "33/40",
    "srank": 7
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Deshna Ojha",
    "orank": 245,
    "prize": "",
    "roll": "AM196802420",
    "school": "Lumbini Public School",
    "score": "23/40",
    "srank": 15
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dibyanshi Biswal",
    "orank": 197,
    "prize": "",
    "roll": "AM196802430",
    "school": "DAV public School Chandrasekharpur",
    "score": "28/40",
    "srank": 12
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dibyanshu Das",
    "orank": 85,
    "prize": "",
    "roll": "AM196809423",
    "school": "K.V. no- 1,(1st shift) BBSR",
    "score": "36 / 40",
    "srank": 4
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Kausik Ranjan Swain",
    "orank": 369,
    "prize": "",
    "roll": "AS196802655",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "17 / 40",
    "srank": 20
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Piyush Kumar Pati",
    "orank": 221,
    "prize": "",
    "roll": "AM196802665",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "27 / 40",
    "srank": 13
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rihanshi Behera",
    "orank": 267,
    "prize": "",
    "roll": "AM196802419",
    "school": "Lumbini Public School",
    "score": "21/40",
    "srank": 16
  },
  {
    "class": "2",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Satyam Anand",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196802654",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aarush Nayak",
    "orank": 3,
    "prize": "Cash award of Rs.1000/- (Prize shared) Olympiad Bronze Medal ",
    "roll": "AR196802658",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 40",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Abhigyan Samal",
    "orank": "",
    "prize": "",
    "roll": "AR196802828",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aditya Mallick",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196802662",
    "school": "Lumbini Public School",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Adyaveer Sahu",
    "orank": 11,
    "prize": "Special Prize",
    "roll": "AR196802821",
    "school": "kendriya vidyalaya no.1 , bhuaneswar",
    "score": "27 / 40",
    "srank": 4
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Amritanshu Das",
    "orank": 102,
    "prize": "",
    "roll": "AR196802655",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "20 / 40",
    "srank": 17
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "ANINDITA SAMAL",
    "orank": 65,
    "prize": "",
    "roll": "AR196802820",
    "school": "DAV CHANDRASEKHARPUR",
    "score": "23 / 40",
    "srank": 11
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ashmit Kumar Mishra",
    "orank": 11,
    "prize": "Special Prize",
    "roll": "AR196802827",
    "school": "DAV CSPUR",
    "score": "27 / 40",
    "srank": 4
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ayushi Senapati",
    "orank": 256,
    "prize": "",
    "roll": "AR196808875",
    "school": "Kendriya Vidyalaya no.1 BBSR",
    "score": "24 / 40",
    "srank": 17
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Chhanda Madhuri sahu",
    "orank": 12,
    "prize": "Special Prize",
    "roll": "AR196806897",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "26 / 40",
    "srank": 8
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Deepanswu Behera",
    "orank": 25,
    "prize": "Special Prize",
    "roll": "AR196802824",
    "school": "Kv no1 Bhubaneswar",
    "score": "25 / 40",
    "srank": 6
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Dibyanshu Das",
    "orank": 23,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196809576",
    "school": "K.V. No:-1 (1st Shift) BBSR",
    "score": "35 / 40",
    "srank": 3
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Divyansh Swain",
    "orank": "",
    "prize": "",
    "roll": "AR196802455",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "",
    "srank": ""
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Gourav Dash",
    "orank": "",
    "prize": "",
    "roll": "AR196802456",
    "school": "Sai International school",
    "score": "",
    "srank": ""
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Gourav Gourinandan Dash",
    "orank": "",
    "prize": "",
    "roll": "AR196802457",
    "school": "Sai International school",
    "score": "",
    "srank": ""
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Hrudananda Sahu",
    "orank": "",
    "prize": "",
    "roll": "AR196802458",
    "school": "Cohen International",
    "score": "",
    "srank": ""
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Jasritha Mohanty",
    "orank": "",
    "prize": "",
    "roll": "AR196802459",
    "school": "Lumbini Public School",
    "score": "",
    "srank": ""
  },
  {
    "class": "2",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Kanvi Krishna Maharana",
    "orank": "",
    "prize": "",
    "roll": "AR196802460",
    "school": "Kendriya Vidyalaya no. 4",
    "score": "",
    "srank": ""
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aarush Nayak",
    "orank": 54,
    "prize": "School Silver Medal",
    "roll": "AS196802355",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "29 / 35",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Abhigyan Samal",
    "orank": "",
    "prize": "",
    "roll": "AS196802549",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Adhwika Kanungo",
    "orank": 256,
    "prize": "",
    "roll": "AS196802344",
    "school": "Lumbini Public School",
    "score": "18 / 35",
    "srank": 9
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aditya Mallick",
    "orank": 54,
    "prize": "School Silver Medal",
    "roll": "AS196802359",
    "school": "Lumbini Public School",
    "score": "29 / 35",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "ADITYA NARAYAN SWAIN",
    "orank": 141,
    "prize": "",
    "roll": "AS196802543",
    "school": "KENDRIYA VIDAYALAYA-1 BBSR",
    "score": "23 / 35",
    "srank": 5
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "ADVIKA MOHANTY",
    "orank": 178,
    "prize": "",
    "roll": "AR196802550",
    "school": "D.A.V PUBLIC SCHOOL UNIT- 8 BBSR",
    "score": "21 / 35",
    "srank": 7
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Adyaveer Sahu",
    "orank": 98,
    "prize": "School Bronze Medal",
    "roll": "AS196802545",
    "school": "Kendriya vidyalaya no 1 Bhubaneswar",
    "score": "27 / 35",
    "srank": 3
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Amritanshu Das",
    "orank": 199,
    "prize": "",
    "roll": "AS196802352",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "20 / 35",
    "srank": 8
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ankit Uthansingh",
    "orank": 54,
    "prize": "School Silver Medal",
    "roll": "AS196802411",
    "school": "Lumbini Public School",
    "score": "29/35",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ayushi Senapati",
    "orank": 20,
    "prize": "School Silver Medal + Special prize",
    "roll": "AS196808525",
    "school": "Kendriya vidyalaya no. 1 Bhubaneswar 1st Shift",
    "score": "34 / 35",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Chhanda Madhuri sahu",
    "orank": 104,
    "prize": "",
    "roll": "AS196806336",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "26 / 35",
    "srank": 4
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Debanshi Parida",
    "orank": 178,
    "prize": "",
    "roll": "AS196802347",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "21 / 35",
    "srank": 7
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Deshna Ojha",
    "orank": 121,
    "prize": "",
    "roll": "AS196802413",
    "school": "Lumbini Public School",
    "score": "25/35",
    "srank": 4
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Dibya Sai Prakash Jena",
    "orank": 165,
    "prize": "",
    "roll": "AS196802414",
    "school": "Lumbini Public School",
    "score": "22/35",
    "srank": 6
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Dibyanshu Das",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196809326",
    "school": "K.V. No- 1 (1st shift) BBSR",
    "score": "35/ 35",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Kausik Ranjan Swain",
    "orank": 299,
    "prize": "",
    "roll": "AS196802343",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "17 / 35",
    "srank": 10
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Krisha Mohanty",
    "orank": 104,
    "prize": "",
    "roll": "AS196802550",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "26/35",
    "srank": 4
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Manindra Bora",
    "orank": 121,
    "prize": "",
    "roll": "AM196802551",
    "school": "DAV CSPur",
    "score": "25/35",
    "srank": 4
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Minerva Siddhi",
    "orank": 141,
    "prize": "",
    "roll": "AS196802552",
    "school": "Cohen International",
    "score": "23/35",
    "srank": 5
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Muktimayurika Mohanty",
    "orank": 54,
    "prize": "School Silver Medal",
    "roll": "AS196802553",
    "school": "DAV Public School, Garage Chhak",
    "score": "29/35",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Piyush Kumar Pati",
    "orank": 98,
    "prize": "School Bronze Medal",
    "roll": "AS196802353",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "27 / 35",
    "srank": 3
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rihanshi Behera",
    "orank": 98,
    "prize": "School Bronze Medal",
    "roll": "AS196802412",
    "school": "Lumbini Public School",
    "score": "27/35",
    "srank": 3
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai Samarpit Rout",
    "orank": 54,
    "prize": "School Silver Medal",
    "roll": "AS196802541",
    "school": "Kendriya vidyalaya 1, shift -1, Bhubaneswar",
    "score": "29 / 35",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Satyam Anand",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196802342",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "35 / 35",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Ayushi Senapati",
    "orank": 74,
    "prize": "School Gold Medal",
    "roll": "SS196802125",
    "school": "Kendriya Vidyalaya no.1 BBSR 1st Shift",
    "score": "32 / 40",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Chhanda Madhuri sahu",
    "orank": 120,
    "prize": "School Silver Medal",
    "roll": "SS196802099",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "20 / 40",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Adhwika Kanungo",
    "orank": 21,
    "prize": "School Gold Medal + Special prize",
    "roll": "AT196802255",
    "school": "Lumbini Public School",
    "score": "38 / 40",
    "srank": 1
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Adyaveer sahu",
    "orank": 158,
    "prize": "",
    "roll": "AT196802758",
    "school": "Kendriya Vidyalaya no 1 BBSR",
    "score": "26 / 40",
    "srank": 7
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "anindita samal",
    "orank": 202,
    "prize": "",
    "roll": "AT196802757",
    "school": "dav chandrasekharpur",
    "score": "20 / 40",
    "srank": 9
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "AYUSHI SENAPATI",
    "orank": "",
    "prize": "",
    "roll": "AT196802573",
    "school": "Kendriya vidyalaya no. 1 Bhubaneswar 1st Shift",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Debanshi Parida",
    "orank": 198,
    "prize": "",
    "roll": "AT196802258",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "22 / 40",
    "srank": 8
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Deepanswu Behera",
    "orank": 264,
    "prize": "",
    "roll": "AT196802756",
    "school": "Kv no1 Bhubaneswar",
    "score": "15 / 40",
    "srank": 11
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Kausik Ranjan Swain",
    "orank": 225,
    "prize": "",
    "roll": "AT196802254",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "18 / 40",
    "srank": 10
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Paree Jena",
    "orank": 96,
    "prize": "",
    "roll": "AM196802255",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "32/40",
    "srank": 4
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Reyannsh Mohapatra",
    "orank": 36,
    "prize": "School Silver Medal + Special prize",
    "roll": "AT196802256",
    "school": "Mount Litra Zee School",
    "score": "37/40",
    "srank": 2
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Rishabh Patnaik",
    "orank": 136,
    "prize": "",
    "roll": "AT196802257",
    "school": "Mount Litra Zee School",
    "score": "30/40",
    "srank": 6
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Tanwesha Moharana",
    "orank": 89,
    "prize": "School Bronze Medal",
    "roll": "AM196802258",
    "school": "Mount Litra Zee School",
    "score": "35/40",
    "srank": 3
  },
  {
    "class": "2",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Tripathy Premjyoti Senapati",
    "orank": 120,
    "prize": "",
    "roll": "AT196802259",
    "school": "Mount Litra Zee School",
    "score": "31/40",
    "srank": 5
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aarav Nayak",
    "orank": 359,
    "prize": "",
    "roll": "AM196803105",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 40",
    "srank": 13
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aarna Das",
    "orank": 186,
    "prize": "School Silver Medal",
    "roll": "AT196803543",
    "school": "St. Xaviers International",
    "score": "35/40",
    "srank": 2
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aarohi Sahoo",
    "orank": 235,
    "prize": "",
    "roll": "AS196803544",
    "school": "St. Xaviers International",
    "score": "32/40",
    "srank": 7
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Abhiraj Panda",
    "orank": 335,
    "prize": "",
    "roll": "AS196803546",
    "school": "Cohen International",
    "score": "28/40",
    "srank": 11
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adhrit Akshat Swain",
    "orank": 235,
    "prize": "",
    "roll": "AM196803547",
    "school": "Cohen International",
    "score": "32/40",
    "srank": 7
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditri Mahapatra",
    "orank": 159,
    "prize": "",
    "roll": "AM196803548",
    "school": "DAV Public School, Unit 9",
    "score": "36/40",
    "srank": 4
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Hruday Mishra",
    "orank": 375,
    "prize": "",
    "roll": "AM196803103",
    "school": "Lumbini Public School",
    "score": "23 / 40",
    "srank": 14
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Prasad Dash ",
    "orank": 289,
    "prize": "",
    "roll": "AM196803549",
    "school": "Kendriya vidyalaya no-1",
    "score": "30/40",
    "srank": 9
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adwita Swain",
    "orank": 65,
    "prize": "School Silver Medal",
    "roll": "AM196803550",
    "school": "D.A.V PUBLIC SCHOOL UNIT- 8 BBSR",
    "score": "38/40",
    "srank": 2
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyansh Mund",
    "orank": "",
    "prize": "",
    "roll": "AM196803551",
    "school": "DAV Public school, CSPur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyant Tripathy",
    "orank": 310,
    "prize": "",
    "roll": "AM196803552",
    "school": "DAV Public school, CSPur",
    "score": "29/40",
    "srank": 10
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Akshyanshu Tripathy",
    "orank": 186,
    "prize": "School Gold Medal",
    "roll": "AM196803545",
    "school": "DAV Public School, Unit 8",
    "score": "35/40",
    "srank": 1
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ankit Singh",
    "orank": 337,
    "prize": "",
    "roll": "AM196803106",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "26 / 40",
    "srank": 12
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ayushman Behera",
    "orank": 392,
    "prize": "",
    "roll": "AM196803542",
    "school": "Lumbini Public School",
    "score": "21/40",
    "srank": 15
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Divyansh Mishra",
    "orank": "",
    "prize": "",
    "roll": "AM196803381",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "divyapallavi baskey",
    "orank": 310,
    "prize": "",
    "roll": "AM196803101",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 40",
    "srank": 10
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jayanta Kumar Samantaray ",
    "orank": 125,
    "prize": "School Bronze Medal",
    "roll": "AM196803443",
    "school": "Lumbini Public School",
    "score": "37/40",
    "srank": 3
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Katyayani Mohanty",
    "orank": 357,
    "prize": "",
    "roll": "AM196803444",
    "school": "Kendriya Vidyalaya no. 4",
    "score": "26/40",
    "srank": 12
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Krisha Subudhi",
    "orank": 235,
    "prize": "",
    "roll": "AM196803445",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "32/40",
    "srank": 7
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Krishna Raj Biswal",
    "orank": 436,
    "prize": "",
    "roll": "AM196803446",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "17/40",
    "srank": 17
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Lakshya Gupta",
    "orank": 310,
    "prize": "",
    "roll": "AM196803447",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "29/40",
    "srank": 10
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Lavik Mohanty",
    "orank": 65,
    "prize": "School Silver Medal",
    "roll": "AM196803448",
    "school": "DAV Unit - 8",
    "score": "38/40",
    "srank": 2
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Manish Chinmaya",
    "orank": 210,
    "prize": "",
    "roll": "AM196803449",
    "school": "DAV CSPur",
    "score": "34/40",
    "srank": 6
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Mirza Taheem Abdullah",
    "orank": 159,
    "prize": "",
    "roll": "AM196803450",
    "school": "Cohen International",
    "score": "36/40",
    "srank": 4
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Nabendu Kumar Mohakud",
    "orank": 259,
    "prize": "",
    "roll": "AM196803451",
    "school": "DAV Public School, Garage Chhak",
    "score": "31/40",
    "srank": 8
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Partha Sarathi Das",
    "orank": 186,
    "prize": "",
    "roll": "AM196803452",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "35/40",
    "srank": 5
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Preetisha Satapathy",
    "orank": 56,
    "prize": "School Gold Medal",
    "roll": "AM196803453",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "39/40",
    "srank": 1
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Priyabrata Behera",
    "orank": 335,
    "prize": "",
    "roll": "AM196803543",
    "school": "Lumbini Public School",
    "score": "28/40",
    "srank": 11
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Reeyansh Roshan",
    "orank": 289,
    "prize": "",
    "roll": "AM196803454",
    "school": "Mount Litra Zee School",
    "score": "30/40",
    "srank": 9
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Reyansh Ray",
    "orank": 235,
    "prize": "",
    "roll": "AM196803455",
    "school": "Mount Litra Zee School",
    "score": "32/40",
    "srank": 7
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rishiraj Nayak",
    "orank": 401,
    "prize": "",
    "roll": "AM196803546",
    "school": "Lumbini Public School",
    "score": "18/40",
    "srank": 16
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ritika Mohapatra",
    "orank": 186,
    "prize": "",
    "roll": "AM196803456",
    "school": "Lumbini Public School",
    "score": "35/40",
    "srank": 5
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Samit sourav sahoo",
    "orank": 65,
    "prize": "School Silver Medal",
    "roll": "AM196803457",
    "school": "Mount Litra Zee School",
    "score": "38/40",
    "srank": 2
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shibanya Rout ",
    "orank": "",
    "prize": "",
    "roll": "AM196803544",
    "school": "DAV Public School, CSPur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shreyansh Kar",
    "orank": 125,
    "prize": "School Bronze Medal",
    "roll": "AM196803458",
    "school": "Kendriya vidyalaya no 8",
    "score": "37/40",
    "srank": 3
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shreyansh Kumar Pradhan",
    "orank": 159,
    "prize": "",
    "roll": "AM196803459",
    "school": "Kendriya vidyalaya no 9",
    "score": "36/40",
    "srank": 4
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shreyansh Kumar Pradhan",
    "orank": 210,
    "prize": "",
    "roll": "AM196803460",
    "school": "Kendriya vidyalaya no 10",
    "score": "34/40",
    "srank": 6
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shreyansh Rout",
    "orank": 259,
    "prize": "",
    "roll": "AM196803461",
    "school": "Kendriya vidyalaya no 14",
    "score": "31/40",
    "srank": 8
  },
  {
    "class": "3",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Tanya Mohanta",
    "orank": 186,
    "prize": "",
    "roll": "AM196803462",
    "school": "Mount Litra Zee School",
    "score": "35/40",
    "srank": 5
  },
  {
    "class": "3",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aarav Nayak",
    "orank": 11,
    "prize": "Special Prize",
    "roll": "AR196803265",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 40",
    "srank": 7
  },
  {
    "class": "3",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aditya Hruday Mishra",
    "orank": 21,
    "prize": "Special Prize",
    "roll": "AR196803263",
    "school": "Lumbini Public School",
    "score": "23 / 40",
    "srank": 8
  },
  {
    "class": "3",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aishani Nanda",
    "orank": "",
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196803241",
    "school": "DAV Public School Cspur",
    "score": "38/40",
    "srank": 3
  },
  {
    "class": "3",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Akankkhya Parida",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196803242",
    "school": "DAV Public School Cspur",
    "score": "40/40",
    "srank": 1
  },
  {
    "class": "3",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Akshyanshu Tripathy",
    "orank": "",
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196803243",
    "school": "DAV Public School Cspur",
    "score": "39/40",
    "srank": 2
  },
  {
    "class": "3",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Amrut Das",
    "orank": "",
    "prize": "",
    "roll": "AR196803244",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "36/40",
    "srank": 4
  },
  {
    "class": "3",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ankit Singh",
    "orank": 9,
    "prize": "Special Prize",
    "roll": "AR196803266",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "26 / 40",
    "srank": 6
  },
  {
    "class": "3",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "divyapallavi baskey",
    "orank": 1,
    "prize": "",
    "roll": "AR196803261",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 40",
    "srank": 5
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aarav Nayak",
    "orank": 287,
    "prize": "",
    "roll": "AS196803224",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 40",
    "srank": 14
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aditya Hruday Mishra",
    "orank": 301,
    "prize": "",
    "roll": "AS196803222",
    "school": "Lumbini Public School",
    "score": "23 / 40",
    "srank": 15
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Akshyanshu Tripathy",
    "orank": 122,
    "prize": "School Gold Medal",
    "roll": "AS196803400",
    "school": "DAV Public school Unit 8, BBSR",
    "score": "34/40",
    "srank": 1
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Anishka Mohapatra",
    "orank": "",
    "prize": "",
    "roll": "AS196803517",
    "school": "dav chandrasekharpur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ankit Singh",
    "orank": 258,
    "prize": "",
    "roll": "AS196803225",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "26 / 40",
    "srank": 13
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Anshuman Barik",
    "orank": 154,
    "prize": "",
    "roll": "AM196803399",
    "school": "Cohen International",
    "score": "33/40",
    "srank": 7
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Anwit Acharya",
    "orank": 2,
    "prize": "Cash award of Rs.1500/- (Prize shared) Olympiad Silver Medal ",
    "roll": "AM196803401",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "39/40",
    "srank": 2
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Arnav panda",
    "orank": 354,
    "prize": "",
    "roll": "AS196803512",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "16 / 40",
    "srank": 16
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Arushi Dash",
    "orank": 4,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196803402",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "38/40",
    "srank": 3
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ashirbad Nayak",
    "orank": 178,
    "prize": "",
    "roll": "AS196803403",
    "school": "Dav public school cspur",
    "score": "32/40",
    "srank": 8
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Atyush Janav Das",
    "orank": 4,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196803404",
    "school": "Kendriya vidyalaya no.1 bbsr",
    "score": "38/40",
    "srank": 3
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ayushman Behera",
    "orank": 245,
    "prize": "",
    "roll": "AS196803398",
    "school": "Lumbini Public School",
    "score": "28/40",
    "srank": 12
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ayusman Padhy",
    "orank": 98,
    "prize": "",
    "roll": "AS196803405",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "35/40",
    "srank": 5
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Chetana Padhi",
    "orank": 169,
    "prize": "",
    "roll": "AS196803406",
    "school": "Mother's public school khandagiri",
    "score": "32/40",
    "srank": 8
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Deblina Samal",
    "orank": 4,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196803407",
    "school": "DAV PUBLIC SCHOOL UNIT - 8 BBSR",
    "score": "38/40",
    "srank": 3
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "divyapallavi baskey",
    "orank": 211,
    "prize": "",
    "roll": "AS196803220",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 40",
    "srank": 10
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Priyabrata Behera",
    "orank": 287,
    "prize": "",
    "roll": "AS196803399",
    "school": "Lumbini Public School",
    "score": "25/40",
    "srank": 14
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rishiraj Nayak",
    "orank": 231,
    "prize": "",
    "roll": "AS196803401",
    "school": "Lumbini Public School",
    "score": "28/40",
    "srank": 12
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ujjwal Patra",
    "orank": 56,
    "prize": "",
    "roll": "AS196803307",
    "school": "Mount Litra Zee School",
    "score": "36/40",
    "srank": 4
  },
  {
    "class": "3",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Yashaswini Rout",
    "orank": 199,
    "prize": "",
    "roll": "AS196803308",
    "school": "Mount Litra Zee School",
    "score": "32/40",
    "srank": 8
  },
  {
    "class": "3",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Amrit Barik",
    "orank": 181,
    "prize": "School Silver Medal",
    "roll": "SS196805091",
    "school": "KV - 4 Bhubaneswar",
    "score": "16 / 40",
    "srank": 2
  },
  {
    "class": "3",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Hrishita Das",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared), Olympiad Gold Medal ",
    "roll": "SS196805092",
    "school": "Cohen International",
    "score": "39/40",
    "srank": 1
  },
  {
    "class": "3",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Aarav Nayak",
    "orank": 198,
    "prize": "",
    "roll": "AM196803557",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 40",
    "srank": 6
  },
  {
    "class": "3",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Aditya Hruday Mishra",
    "orank": 198,
    "prize": "",
    "roll": "AT196803555",
    "school": "Lumbini Public School",
    "score": "25 / 40",
    "srank": 6
  },
  {
    "class": "3",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Ankit Singh",
    "orank": 89,
    "prize": "",
    "roll": "AM196803558",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 40",
    "srank": 4
  },
  {
    "class": "3",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Chinmay Nandi",
    "orank": 210,
    "prize": "",
    "roll": "AT196805724",
    "school": "Kendriya vidyalaya no 1 Bhubaneswar",
    "score": "23 / 40",
    "srank": 7
  },
  {
    "class": "3",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Deepam Kumar Upadhyaya",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AT196803556",
    "school": "DAV PUBLIC SCHOOL UNIT - 8 BBSR",
    "score": "40/40",
    "srank": 1
  },
  {
    "class": "3",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Dibyanshi Sahoo",
    "orank": 54,
    "prize": "",
    "roll": "AT196803557",
    "school": "DAV public School Chandrasekharpur",
    "score": "38/40",
    "srank": 2
  },
  {
    "class": "3",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Divyanshee Biswal",
    "orank": 69,
    "prize": "School Bronze Medal",
    "roll": "AT196803558",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "37/40",
    "srank": 3
  },
  {
    "class": "3",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Goutami Saishradha Biswal",
    "orank": 125,
    "prize": "",
    "roll": "AT196803559",
    "school": "D.A.V. Public School",
    "score": "27/4",
    "srank": 5
  },
  {
    "class": "4 ",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Arnav Kunar",
    "orank": 98,
    "prize": "School Silver Medal",
    "roll": "SS196804352",
    "school": "Sai International school",
    "score": "34/40",
    "srank": 2
  },
  {
    "class": "4 ",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rajveer Parida",
    "orank": 235,
    "prize": "",
    "roll": "SS196804355",
    "school": "Lumbini Public School",
    "score": "25/40",
    "srank": 5
  },
  {
    "class": "4 ",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai Priyanshu Rout",
    "orank": 146,
    "prize": "School Bronze Medal",
    "roll": "SS196804354",
    "school": "Lumbini Public School",
    "score": "30/40",
    "srank": 3
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aadarsh Baliarsingh",
    "orank": 145,
    "prize": "",
    "roll": "AS196804471",
    "school": "St. Xavier high School, Satyanagar",
    "score": "40/45",
    "srank": 6
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aahana Chetna Panda",
    "orank": 510,
    "prize": "",
    "roll": "AM196804423",
    "school": "DAV Public School , Chandrasekharpur",
    "score": "19 / 45",
    "srank": 25
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aarohi Mahapatra",
    "orank": 278,
    "prize": "",
    "roll": "AT196804472",
    "school": "St. Xaviers International",
    "score": "36/45",
    "srank": 10
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aarohi Mishra",
    "orank": 145,
    "prize": "",
    "roll": "AM196804199",
    "school": "St. Xaviers International",
    "score": "40/45",
    "srank": 6
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Abhimeet Nayak",
    "orank": 356,
    "prize": "",
    "roll": "AM196804204",
    "school": "Cohen International",
    "score": "31/45",
    "srank": 14
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "ABHYUDAY SWAIN",
    "orank": "",
    "prize": "",
    "roll": "AM196804447",
    "school": "Cohen International",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adarsh Sahu",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196804704",
    "school": "Cohen International",
    "score": "45/45",
    "srank": 1
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Narayan",
    "orank": 461,
    "prize": "",
    "roll": "AM196804109",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "23 / 45",
    "srank": 21
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Prasad Biswal",
    "orank": 494,
    "prize": "",
    "roll": "AS196804427",
    "school": "Kendriya vidyalaya no-1",
    "score": "20 / 45",
    "srank": 24
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Samal",
    "orank": 198,
    "prize": "",
    "roll": "AM196804702",
    "school": "Kendriya vidyalaya no 1",
    "score": "39/45",
    "srank": 7
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyansh Padhy",
    "orank": 45,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196804705",
    "school": "DAV Public school, CSPur",
    "score": "43/45",
    "srank": 3
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aishurya Akshaya Kumar Jena",
    "orank": 101,
    "prize": "",
    "roll": "AM196804706",
    "school": "DAV Public School Cspur",
    "score": "41/45",
    "srank": 5
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Akankshya Mishra",
    "orank": 312,
    "prize": "",
    "roll": "AM196804709",
    "school": "DAV Public School Cspur",
    "score": "34/45",
    "srank": 12
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Akshyat Aadit Sahu",
    "orank": "",
    "prize": "",
    "roll": "AM196804710",
    "school": "DAV Public School Cspur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Alisha Swain",
    "orank": "",
    "prize": "",
    "roll": "AS196804445",
    "school": "Kendriya Vidyalaya No .1 Bubaneswar",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amrut Dash",
    "orank": 198,
    "prize": "",
    "roll": "AM196804711",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "39/45",
    "srank": 7
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ananya Rout",
    "orank": "",
    "prize": "",
    "roll": "AS196804444",
    "school": "Lumbini Public school",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anaya Sahu",
    "orank": 299,
    "prize": "",
    "roll": "AM196804712",
    "school": "Lumbini Public school",
    "score": "35/45",
    "srank": 11
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Angel Francis Nayak",
    "orank": 371,
    "prize": "",
    "roll": "AM196805228",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 45",
    "srank": 15
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aniket Aryaveer Dora",
    "orank": 145,
    "prize": "",
    "roll": "AM196804713",
    "school": "DAV CHANDRASEKHARPUR",
    "score": "40/45",
    "srank": 6
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aniket Pradhan",
    "orank": 96,
    "prize": "",
    "roll": "AS196804109",
    "school": "DAV CHANDRASEKHARPUR",
    "score": "42/45",
    "srank": 4
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anish Nayak",
    "orank": 45,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "SS196804423",
    "school": "dav chandrasekharpur",
    "score": "43/45",
    "srank": 3
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anshuprit Dutta",
    "orank": 521,
    "prize": "",
    "roll": "AM196804427",
    "school": "Cohen International",
    "score": "17/45",
    "srank": 26
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesha Biswal",
    "orank": 278,
    "prize": "",
    "roll": "AM196804429",
    "school": "Cohen International",
    "score": "36/45",
    "srank": 10
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwita Behera",
    "orank": 101,
    "prize": "",
    "roll": "AR196804450",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "41/45",
    "srank": 5
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Arnav Kunar",
    "orank": "",
    "prize": "",
    "roll": "AM196804468",
    "school": "Sai International school",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "ARPITA SWAIN",
    "orank": 421,
    "prize": "",
    "roll": "AM196804450",
    "school": "KV NO 1 BHUBANESWAR",
    "score": "26 / 45",
    "srank": 18
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Arya Abhiraj Swain",
    "orank": 45,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196804444",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "43/45",
    "srank": 3
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ashutosh Maharana",
    "orank": 45,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196804445",
    "school": "ODM Public School",
    "score": "43/45",
    "srank": 3
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Avanija Panigrahi ",
    "orank": 21,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AR196804446",
    "school": "Kendriya vidyalaya no.1 bbsr",
    "score": "44/45",
    "srank": 2
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ayansh Mishra",
    "orank": "",
    "prize": "",
    "roll": "AS196804447",
    "school": "Bal Bharati Public School",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ayonika samal",
    "orank": "",
    "prize": "",
    "roll": "AT196804429",
    "school": "Bal Bharati Public School",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "B. Khushi Patra",
    "orank": "",
    "prize": "",
    "roll": "AS196805228",
    "school": "DAV Public School, CSPur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Chirag Senapati",
    "orank": 335,
    "prize": "",
    "roll": "AM196804254",
    "school": "St. Xaviers, Dist. Centre",
    "score": "32/45",
    "srank": 13
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dakshya Mishra",
    "orank": 221,
    "prize": "",
    "roll": "AM196804371",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "38/45",
    "srank": 8
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Debanshi Mohanty",
    "orank": 145,
    "prize": "",
    "roll": "AM196804372",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "40/45",
    "srank": 6
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Deeshna Dibyanshi Sahoo",
    "orank": 312,
    "prize": "",
    "roll": "AM196804373",
    "school": "Lumbini Public School",
    "score": "34/45",
    "srank": 12
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dheeraaj Sethi",
    "orank": 436,
    "prize": "",
    "roll": "AM196801702",
    "school": "ODM Public School",
    "score": "25 / 45",
    "srank": 19
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dibya Sai Prakash Jena",
    "orank": 371,
    "prize": "",
    "roll": "AM196804472",
    "school": "Lumbini Public School",
    "score": "29/45",
    "srank": 15
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Eashan Pattanayak",
    "orank": 278,
    "prize": "",
    "roll": "AM196804375",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "36/45",
    "srank": 10
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Harsh Nath",
    "orank": 245,
    "prize": "",
    "roll": "AM196804376",
    "school": "DAV Public School, Chandrasekharpur, Bhubaneswar-22",
    "score": "37/45",
    "srank": 9
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jaydeep Rath",
    "orank": 21,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196804377",
    "school": "Lumbini Public School",
    "score": "44/45",
    "srank": 2
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Kesan Kumar Behera",
    "orank": 101,
    "prize": "",
    "roll": "AM196804378",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "41/45",
    "srank": 5
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Krivansh Rath",
    "orank": 198,
    "prize": "",
    "roll": "AM196804379",
    "school": "Lumbini Public School",
    "score": "39/45",
    "srank": 7
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Lalit Mohanty",
    "orank": 278,
    "prize": "",
    "roll": "AM196804380",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "36/45",
    "srank": 10
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Laxmi Narayan Mishra",
    "orank": 335,
    "prize": "",
    "roll": "AM196804381",
    "school": "Lumbini Public School",
    "score": "32/45",
    "srank": 13
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Madhusmita sahoo",
    "orank": 444,
    "prize": "",
    "roll": "AM196804446",
    "school": "Kendriya vidhyalaya no 1 Bhubaneswar",
    "score": "24 / 45",
    "srank": 20
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Manish Kumar Pradhan",
    "orank": 356,
    "prize": "",
    "roll": "AM196804382",
    "school": "KV no.1 bhubaneswer 1st shift",
    "score": "31/45",
    "srank": 14
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Mitesh Pradhan",
    "orank": 145,
    "prize": "",
    "roll": "AM196804383",
    "school": "Cohen International",
    "score": "40/45",
    "srank": 6
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Nachiket Ghadei",
    "orank": 45,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196804384",
    "school": "DAV Public School, Garage Chhak",
    "score": "43/45",
    "srank": 3
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Nimesh Nayak",
    "orank": 21,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196804385",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "44/45",
    "srank": 2
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Piyali Saxena",
    "orank": 101,
    "prize": "",
    "roll": "AM196804386",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "41/45",
    "srank": 5
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Preetika Pradhan",
    "orank": 278,
    "prize": "",
    "roll": "AM196804387",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "36/45",
    "srank": 10
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Purvesh Kumar Swain",
    "orank": 461,
    "prize": "",
    "roll": "AM196801711",
    "school": "DAV public school",
    "score": "23 / 45",
    "srank": 21
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rajveer Parida",
    "orank": 486,
    "prize": "",
    "roll": "AM196804471",
    "school": "Lumbini Public School",
    "score": "21/45",
    "srank": 23
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Reedhi Sahoo",
    "orank": 389,
    "prize": "",
    "roll": "AM196804388",
    "school": "Mount Litra Zee School",
    "score": "28/45",
    "srank": 16
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Reyan Prusty",
    "orank": 198,
    "prize": "",
    "roll": "AM196804389",
    "school": "Mount Litra Zee School",
    "score": "39/45",
    "srank": 7
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rudransh Pradhan",
    "orank": 486,
    "prize": "",
    "roll": "AM196801701",
    "school": "Lumbini Public School",
    "score": "21 / 45",
    "srank": 23
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai Priyanshu Rout",
    "orank": 461,
    "prize": "",
    "roll": "AM196804470",
    "school": "Lumbini Public School",
    "score": "23/45",
    "srank": 21
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai Shibam Swain ",
    "orank": 436,
    "prize": "",
    "roll": "AM196801713",
    "school": "Lumbini Public School",
    "score": "25 / 45",
    "srank": 19
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sampurna Panda",
    "orank": 278,
    "prize": "",
    "roll": "AM196804390",
    "school": "Mount Litra Zee School",
    "score": "36/45",
    "srank": 10
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Saswat Behera",
    "orank": 472,
    "prize": "",
    "roll": "AM196801201",
    "school": "DAV public school",
    "score": "22 / 45",
    "srank": 22
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shanvi Nayak",
    "orank": 401,
    "prize": "",
    "roll": "AM196801709",
    "school": "DAV public school",
    "score": "27 / 45",
    "srank": 17
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shreyan Subudhi",
    "orank": 371,
    "prize": "",
    "roll": "AM196804391",
    "school": "Kendriya vidyalaya no 4",
    "score": "29/45",
    "srank": 15
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shreyanjit Panda",
    "orank": 221,
    "prize": "",
    "roll": "AM196804583",
    "school": "Kendriya vidyalaya no 5",
    "score": "38/45",
    "srank": 8
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shreyansh Swain",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196801712",
    "school": "Lumbini Public School",
    "score": "45 / 45",
    "srank": 1
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shriyansh Mishra",
    "orank": 145,
    "prize": "",
    "roll": "AM196804584",
    "school": "Mount Litra Zee School",
    "score": "40/45",
    "srank": 6
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shruti Bhargavi Pati",
    "orank": "",
    "prize": "",
    "roll": "AM196804585",
    "school": "Mount Litra Zee School",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Siyanshi Sahoo",
    "orank": 472,
    "prize": "",
    "roll": "AM196801710",
    "school": "DAV public school",
    "score": "22 / 45",
    "srank": 22
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Stuti Lagna Mohanty",
    "orank": 389,
    "prize": "",
    "roll": "AM196801199",
    "school": "Vikash Global School bhuanswar",
    "score": "28 / 45",
    "srank": 16
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Subhashree Swastika Sahu",
    "orank": 521,
    "prize": "",
    "roll": "AM196801705",
    "school": "Sai International school",
    "score": "17 / 45",
    "srank": 26
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Suchit Maitra",
    "orank": 389,
    "prize": "",
    "roll": "AM196801706",
    "school": "Lumbini Public School",
    "score": "28 / 45",
    "srank": 16
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sunit Kumar Sahoo",
    "orank": 371,
    "prize": "",
    "roll": "AM196804586",
    "school": "Mount Litra Zee School",
    "score": "29/45",
    "srank": 15
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Susree Sulagna Behera",
    "orank": 486,
    "prize": "",
    "roll": "AM196804587",
    "school": "Mount Litra Zee School",
    "score": "21/45",
    "srank": 23
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Suvam Tripathy",
    "orank": 198,
    "prize": "",
    "roll": "AM196804588",
    "school": "Mount Litra Zee School",
    "score": "39/45",
    "srank": 7
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Suvan Nath",
    "orank": 221,
    "prize": "",
    "roll": "AM196804589",
    "school": "Mount Litra Zee School",
    "score": "38/45",
    "srank": 8
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Yuven Jayasingh",
    "orank": 245,
    "prize": "",
    "roll": "AM196804590",
    "school": "Mount Litra Zee School",
    "score": "37/45",
    "srank": 9
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Zeeshan Abideen",
    "orank": "",
    "prize": "",
    "roll": "AM196804591",
    "school": "Mount Litra Zee School",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Zoya Akhtar",
    "orank": 278,
    "prize": "",
    "roll": "AM196804592",
    "school": "Mount Litra Zee School",
    "score": "36/45",
    "srank": 10
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aahana Chetna Panda",
    "orank": 212,
    "prize": "",
    "roll": "AR196804598",
    "school": "DAV Public School , Chandrasekharpur",
    "score": "13 / 40",
    "srank": 12
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "ABHYUDAY SWAIN",
    "orank": 12,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196804606",
    "school": "Cohen International",
    "score": "39/40",
    "srank": 2
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aditya Narayan",
    "orank": 158,
    "prize": "",
    "roll": "AR196804410",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "23 / 40",
    "srank": 9
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Angel Francis Nayak",
    "orank": 56,
    "prize": "",
    "roll": "AR196804573",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 40",
    "srank": 4
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "B. Khushi Patra",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196804254",
    "school": "DAV Public School, CSPur",
    "score": "40/40",
    "srank": 1
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Chirag Senapati",
    "orank": 26,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196804412",
    "school": "St. Xaviers, Dist. Centre",
    "score": "36/40",
    "srank": 3
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Dheeraaj Sethi",
    "orank": 120,
    "prize": "",
    "roll": "AR196801397",
    "school": "ODM Public School",
    "score": "25 / 40",
    "srank": 7
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Rudransh Pradhan",
    "orank": 171,
    "prize": "",
    "roll": "AR196801396",
    "school": "Lumbini Public School",
    "score": "21 / 40",
    "srank": 10
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Saswat Behera",
    "orank": 135,
    "prize": "",
    "roll": "AR196801523",
    "school": "DAV public school",
    "score": "24 / 40",
    "srank": 8
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Shanvi Nayak",
    "orank": 91,
    "prize": "",
    "roll": "AR196801404",
    "school": "DAV public school",
    "score": "27 / 40",
    "srank": 6
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Subhashree Swastika Sahu",
    "orank": 198,
    "prize": "",
    "roll": "AR196801400",
    "school": "Sai International school",
    "score": "17 / 40",
    "srank": 11
  },
  {
    "class": "4",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Suchit Maitra",
    "orank": 79,
    "prize": "",
    "roll": "AR196801401",
    "school": "Lumbini Public School",
    "score": "28 / 40",
    "srank": 5
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aadwik Mishra",
    "orank": 215,
    "prize": "",
    "roll": "AS196804602",
    "school": "DAV Public School, Chandrasekharpur",
    "score": "23 / 40",
    "srank": 15
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aahana Chetna Panda",
    "orank": 236,
    "prize": "",
    "roll": "AS196804601",
    "school": "DAV PUBLIC SCHOOL",
    "score": "22 / 40",
    "srank": 21
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "ABHYUDAY SWAIN",
    "orank": "",
    "prize": "",
    "roll": "AS196804614",
    "school": "Cohen International",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aditya Narayan",
    "orank": 215,
    "prize": "",
    "roll": "AS196804451",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "23 / 40",
    "srank": 15
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Alisha Swain",
    "orank": 179,
    "prize": "",
    "roll": "AS196804606",
    "school": "Kendriya Vidyalaya No .1 Bubaneswar",
    "score": "25/40",
    "srank": 11
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Angel Francis Nayak",
    "orank": 98,
    "prize": "",
    "roll": "AS196804556",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 40",
    "srank": 8
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "B. Khushi Patra",
    "orank": 52,
    "prize": "",
    "roll": "AS196804324 ",
    "school": "DAV Public School, CSPur",
    "score": "37/40",
    "srank": 7
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Chirag Senapati",
    "orank": 32,
    "prize": "Special Prize",
    "roll": "AS196804214",
    "school": "St. Xaviers, Dist. Centre",
    "score": "39/40",
    "srank": 5
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Dheeraaj Sethi",
    "orank": 194,
    "prize": "",
    "roll": "AS196804131",
    "school": "ODM Public School",
    "score": "25 / 40",
    "srank": 11
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "HARSHIT DAS",
    "orank": 41,
    "prize": "Special Prize",
    "roll": "AS196804524",
    "school": "DAV PUBLIC SCHOOL,CHANDRASEKHARPUR,BBSR",
    "score": "38 / 40",
    "srank": 6
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Madhusmita sahoo",
    "orank": 236,
    "prize": "",
    "roll": "AS196804613",
    "school": "K.V no 1 Bhubaneswar",
    "score": "22 / 40",
    "srank": 21
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "PREKSHYA PURBASHA BARAL",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196804327",
    "school": "KENDRIYA VIDYALAYA NO-1 (2ND SHIFT ) BHUBANESWAR",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Purvesh Kumar Swain",
    "orank": 215,
    "prize": "",
    "roll": "AS196804140",
    "school": "DAV public school",
    "score": "23 / 40",
    "srank": 15
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rudransh Pradhan",
    "orank": 268,
    "prize": "",
    "roll": "AS196804150",
    "school": "Lumbini Public School",
    "score": "21 / 40",
    "srank": 25
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai Shibam Swain ",
    "orank": 194,
    "prize": "",
    "roll": "AS196804142",
    "school": "Lumbini Public School",
    "score": "25 / 40",
    "srank": 11
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Saswat Behera",
    "orank": 268,
    "prize": "",
    "roll": "AS196804431",
    "school": "DAV public school",
    "score": "21 / 40",
    "srank": 25
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shantiswarup Sahoo",
    "orank": "",
    "prize": "",
    "roll": "AS196804612",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shanvi Nayak",
    "orank": 168,
    "prize": "",
    "roll": "AS196804138",
    "school": "DAV public school",
    "score": "27 / 40",
    "srank": 10
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shreyansh Swain",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196804141",
    "school": "Lumbini Public School",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Siyanshi Sahoo",
    "orank": 236,
    "prize": "",
    "roll": "AS196804139",
    "school": "DAV public school",
    "score": "22 / 40",
    "srank": 21
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Stuti Lagna Mohanty",
    "orank": 194,
    "prize": "",
    "roll": "AS196804450",
    "school": "Vikash Global School BBSR",
    "score": "25 / 40",
    "srank": 11
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Subhashree Swastika Sahu",
    "orank": 297,
    "prize": "",
    "roll": "AS196804134",
    "school": "Sai International school",
    "score": "17 / 40",
    "srank": 25
  },
  {
    "class": "4",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Suchit Maitra",
    "orank": 125,
    "prize": "",
    "roll": "AS196804135",
    "school": "Lumbini Public School",
    "score": "28 / 40",
    "srank": 9
  },
  {
    "class": "4",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "ABHYUDAY SWAIN",
    "orank": "",
    "prize": "",
    "roll": "SS196804121",
    "school": "Cohen International",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "B. Khushi Patra",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared), Olympiad Gold Medal ",
    "roll": "SS196804145",
    "school": "DAV Public School, CSPur",
    "score": "40/40",
    "srank": 1
  },
  {
    "class": "4",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Manish Dev Das",
    "orank": 198,
    "prize": "",
    "roll": "SS196804119",
    "school": "KV no.1 bhubaneswer 1st shift",
    "score": "28 / 40",
    "srank": 4
  },
  {
    "class": "4",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "ABHYUDAY SWAIN",
    "orank": "",
    "prize": "",
    "roll": "AT196804816",
    "school": "Cohen International",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "4",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Aditya Narayan",
    "orank": 231,
    "prize": "",
    "roll": "AT196804462",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "27 / 40",
    "srank": 4
  },
  {
    "class": "4",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Angel Francis Nayak",
    "orank": 174,
    "prize": "School Bronze Medal",
    "roll": "AT196805264",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 40",
    "srank": 3
  },
  {
    "class": "4",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Arnav Kunar",
    "orank": 98,
    "prize": "School Gold Medal ",
    "roll": "AT196804329",
    "school": "Sai International school",
    "score": "39/40",
    "srank": 1
  },
  {
    "class": "4",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "B. Khushi Patra",
    "orank": 125,
    "prize": "",
    "roll": "AT196804165",
    "school": "DAV Public School, CSPur",
    "score": "36/40",
    "srank": 2
  },
  {
    "class": "4",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Madhusmita Sahoo",
    "orank": 298,
    "prize": "",
    "roll": "AT196804815",
    "school": "K.V No-1 Bhubaneswar",
    "score": "26 / 40",
    "srank": 5
  },
  {
    "class": "4",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Saswat Behera",
    "orank": 321,
    "prize": "",
    "roll": "AT196804604",
    "school": "DAV Public School",
    "score": "22 / 40",
    "srank": 6
  },
  {
    "class": "4",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Shanvi Nayak",
    "orank": 265,
    "prize": "",
    "roll": "AT196804403",
    "school": "DAV public school",
    "score": "27 / 40",
    "srank": 4
  },
  {
    "class": "4",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Siyanshi Sahoo",
    "orank": 321,
    "prize": "",
    "roll": "AT196804404",
    "school": "DAV public school",
    "score": "22 / 40",
    "srank": 6
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "A. Soumik Kumar",
    "orank": 321,
    "prize": "",
    "roll": "AM196805461",
    "school": "St. Xavier high School, Satyanagar",
    "score": "30/50",
    "srank": 42
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aadi Sai Sahoo",
    "orank": 254,
    "prize": "",
    "roll": "AM196805462",
    "school": "St. Xavier high School, Satyanagar",
    "score": "35/50",
    "srank": 32
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aanvi Sudip Kumar",
    "orank": 102,
    "prize": "",
    "roll": "AM196805463",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "45/50",
    "srank": 18
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aarush Das",
    "orank": 41,
    "prize": "Special Prize",
    "roll": "AM196805464",
    "school": "St. Xaviers International",
    "score": "47/50",
    "srank": 16
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aastha Anvita",
    "orank": 23,
    "prize": "Special Prize",
    "roll": "AM196805465",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "49/50",
    "srank": 12
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Abhigyan Samal",
    "orank": 294,
    "prize": "",
    "roll": "AM196805466",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "31/50",
    "srank": 36
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "ABHIJNAN MOHANTY",
    "orank": 351,
    "prize": "",
    "roll": "AM196805498",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "29 / 50",
    "srank": 45
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Satapathy",
    "orank": 89,
    "prize": "",
    "roll": "AM196805467",
    "school": "Kendriya vidyalaya no 1",
    "score": "46/50",
    "srank": 17
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adwika Mohanty",
    "orank": 124,
    "prize": "",
    "roll": "AM196805468",
    "school": "D.A.V PUBLIC SCHOOL UNIT- 8 BBSR",
    "score": "41/50",
    "srank": 19
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyanshu Rout",
    "orank": 136,
    "prize": "",
    "roll": "AM196805469",
    "school": "DAV Public school, CSPur",
    "score": "40/50",
    "srank": 24
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyasha Mohapatra",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196805225",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aiswanya Biswal",
    "orank": 158,
    "prize": "",
    "roll": "AM196805470",
    "school": "DAV Public School Cspur",
    "score": "39/50",
    "srank": 26
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amal Mishra",
    "orank": "",
    "prize": "",
    "roll": "AM196805471",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amruta Dash",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196805472",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ananya Priyadarshini",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "AM196805473",
    "school": "Lumbini Public school",
    "score": "48/50",
    "srank": 15
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anchit Arman Pati",
    "orank": 23,
    "prize": "Special Prize",
    "roll": "AM196805474",
    "school": "Lumbini Public school",
    "score": "49/50",
    "srank": 12
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anisha Das",
    "orank": 124,
    "prize": "",
    "roll": "AM196805475",
    "school": "dav chandrasekharpur",
    "score": "41/50",
    "srank": 19
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesha Dalai",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196805376",
    "school": "Lumbini Public School",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aradhya Garnaik",
    "orank": "",
    "prize": "",
    "roll": "AM196805508",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aradhya Mohanty",
    "orank": 201,
    "prize": "",
    "roll": "AM196805373",
    "school": "Lumbini Public School",
    "score": "37/50",
    "srank": 31
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aronika Purohit",
    "orank": 511,
    "prize": "",
    "roll": "AM196805507",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "21 / 50",
    "srank": 75
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Avipsa Panda",
    "orank": 389,
    "prize": "",
    "roll": "AM196802657",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "27 / 50",
    "srank": 56
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Baibhav Kumar",
    "orank": 41,
    "prize": "Special Prize",
    "roll": "AM196805235",
    "school": "DAV Public School, CSPur",
    "score": "47/50",
    "srank": 16
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bhabana ",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196802668",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bibartan Singh",
    "orank": 421,
    "prize": "",
    "roll": "AM196802663",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 62
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Deshna Ojha",
    "orank": 558,
    "prize": "",
    "roll": "AM196802669",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "15 / 50",
    "srank": 85
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Diljit Patra",
    "orank": 489,
    "prize": "",
    "roll": "AM196802661",
    "school": "Lumbini Public School",
    "score": "23 / 50",
    "srank": 69
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Disha priyadarshini",
    "orank": 421,
    "prize": "",
    "roll": "AM196802211",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "25 / 50",
    "srank": 62
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Divyanshi Drishya",
    "orank": 1,
    "prize": "",
    "roll": "AS196802212",
    "school": "DAV CHANDRASEKHARPUR BBSR",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Divyanshi Drishya",
    "orank": 378,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196802212",
    "school": "DAV Chandrasekharpur BBSR",
    "score": "28 / 50",
    "srank": 51
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jaykrish Das",
    "orank": 254,
    "prize": "",
    "roll": "AM196805371",
    "school": "Lumbini Public School",
    "score": "35/50",
    "srank": 32
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Kaustav Samantaray ",
    "orank": 389,
    "prize": "",
    "roll": "AM196805229",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "27 / 50",
    "srank": 56
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Lipsa Acharya",
    "orank": 294,
    "prize": "",
    "roll": "AM196805372",
    "school": "Lumbini Public School",
    "score": "31/50",
    "srank": 36
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Maheshi Naik",
    "orank": 456,
    "prize": "",
    "roll": "AM196802662",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "24 / 50",
    "srank": 65
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Manyata Sethi",
    "orank": 351,
    "prize": "",
    "roll": "AM196805370",
    "school": "Lumbini Public School",
    "score": "29/50",
    "srank": 45
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Nirnay Bibhudatta",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196805250",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "P. Deeksha",
    "orank": 287,
    "prize": "",
    "roll": "AM196805375",
    "school": "Lumbini Public School",
    "score": "32/50",
    "srank": 35
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Palaksai Mohanty",
    "orank": 524,
    "prize": "",
    "roll": "AM196802658",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "20 / 50",
    "srank": 81
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Pratyanshu Patnaik",
    "orank": 378,
    "prize": "",
    "roll": "AM196802218",
    "school": "DAV Public School, Chandrasekharpur bhubaneswar",
    "score": "28 / 50",
    "srank": 51
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rihanshi Behera",
    "orank": 456,
    "prize": "",
    "roll": "AM196802672",
    "school": "Lumbini Public School",
    "score": "24 / 50",
    "srank": 65
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rishaan Barick",
    "orank": 499,
    "prize": "",
    "roll": "AM196802670",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "22 / 50",
    "srank": 71
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai Srimaya Sahoo",
    "orank": "",
    "prize": "",
    "roll": "AM196802210",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sanvi Gupta",
    "orank": 511,
    "prize": "",
    "roll": "AM196802213",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "21 / 50",
    "srank": 75
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Saswat Jagadev",
    "orank": 499,
    "prize": "",
    "roll": "AM196805217",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "22 / 50",
    "srank": 71
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shivam Paital",
    "orank": 401,
    "prize": "",
    "roll": "AM196802666",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "26 / 50",
    "srank": 59
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "SIDDHIMA BEHERA",
    "orank": "",
    "prize": "",
    "roll": "AM196802221",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Smruti Smaranika Pradhan",
    "orank": 294,
    "prize": "",
    "roll": "AM196805369",
    "school": "Lumbini Public School",
    "score": "31/50",
    "srank": 36
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Soumya Ranjan Nayak",
    "orank": 578,
    "prize": "",
    "roll": "AM196804428",
    "school": "KV No. 1Bhubaneswar, Khurda, Odisha",
    "score": "14 / 50",
    "srank": 92
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sriya Rani Panda",
    "orank": 294,
    "prize": "",
    "roll": "AM196805374",
    "school": "Lumbini Public School",
    "score": "31/50",
    "srank": 36
  },
  {
    "class": "5",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Tejash singh",
    "orank": 351,
    "prize": "",
    "roll": "AM196802219",
    "school": "Kv2, balangir",
    "score": "29 / 50",
    "srank": 45
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "ABHIJNAN MOHANTY",
    "orank": 278,
    "prize": "",
    "roll": "AR196805917",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "21 / 50",
    "srank": 17
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Adyasha Mohapatra",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196805570",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Anjaneya Padhihari",
    "orank": 79,
    "prize": "",
    "roll": "AR196805552",
    "school": "dav chandrasekharpur",
    "score": "45/50",
    "srank": 5
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Antariksha Dhal",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196805553",
    "school": "Cohen International",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Anwesha Mishra ",
    "orank": 56,
    "prize": "",
    "roll": "AR196805554",
    "school": "Lumbini Public School",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Anwesha Nanda",
    "orank": 115,
    "prize": "",
    "roll": "AR196806899",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "40 / 50",
    "srank": 7
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aradhya Mohanty",
    "orank": 167,
    "prize": "",
    "roll": "AR196806902",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "31 / 50",
    "srank": 9
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Arihant Agarwal",
    "orank": 99,
    "prize": "",
    "roll": "AR196805555",
    "school": "St. Xaviers Dist. Centre",
    "score": "43/50",
    "srank": 6
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "ARONIKA PUROHIT",
    "orank": "",
    "prize": "",
    "roll": "AR196805923",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Arpita Panda",
    "orank": 56,
    "prize": "",
    "roll": "AR196805556",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Arya Ansuman",
    "orank": 145,
    "prize": "",
    "roll": "AR196805557",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "35/50",
    "srank": 8
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aslesha Swain ",
    "orank": 49,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196805558",
    "school": "ODM Public School",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Avilipsa Swain",
    "orank": 23,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196805559",
    "school": "Kendriya vidyalaya no.1 bbsr",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ayeush Mohapatra",
    "orank": 79,
    "prize": "",
    "roll": "AR196805560",
    "school": "Bal Bharati Public School",
    "score": "45/50",
    "srank": 5
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Bhabana ",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196802659",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Bibartan Singh",
    "orank": 212,
    "prize": "",
    "roll": "AR196802654",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 14
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Deshna Ojha",
    "orank": 325,
    "prize": "",
    "roll": "AR196802660",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "15 / 50",
    "srank": 18
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Diljit Patra",
    "orank": 265,
    "prize": "",
    "roll": "AR196802652",
    "school": "Lumbini Public School",
    "score": "23 / 50",
    "srank": 16
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "DISHA PRIYADARSHINI",
    "orank": "",
    "prize": "",
    "roll": "AR196802817",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Divyanshi Drishya",
    "orank": 179,
    "prize": "",
    "roll": "AR196802818",
    "school": "DAV Chandraseksharpur public school BBSR",
    "score": "28 / 50",
    "srank": 10
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Hridesh Ray",
    "orank": 212,
    "prize": "",
    "roll": "AR196802822",
    "school": "DAV PUBLIC SCHOOL",
    "score": "25 / 50",
    "srank": 13
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Kaustav Samantaray ",
    "orank": 185,
    "prize": "",
    "roll": "AR196805574",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "27 / 50",
    "srank": 11
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Maheshi Naik",
    "orank": 235,
    "prize": "",
    "roll": "AR196802653",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "24 / 50",
    "srank": 15
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Nirnay Bibhudatta",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196805575",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Pratyanshu Patnaik",
    "orank": 185,
    "prize": "",
    "roll": "AR196802825",
    "school": "DAV Public School cs pur Bhubaneswar",
    "score": "27 / 50",
    "srank": 11
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Prayan Ghosh",
    "orank": 212,
    "prize": "",
    "roll": "AR196802819",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "25 / 50",
    "srank": 13
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Rihanshi Behera",
    "orank": 235,
    "prize": "",
    "roll": "AR196802663",
    "school": "Lumbini Public School",
    "score": "24 / 50",
    "srank": 15
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Saswat Jagadev",
    "orank": 278,
    "prize": "",
    "roll": "AR196802823",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "21 / 50",
    "srank": 17
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Shivam Paital",
    "orank": 199,
    "prize": "",
    "roll": "AR196802657",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "26 / 50",
    "srank": 12
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "SIDDHIMA BEHERA",
    "orank": "",
    "prize": "",
    "roll": "AR196802829",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Tejash Singh",
    "orank": 179,
    "prize": "",
    "roll": "AR196802826",
    "school": "Kv-2 Bolangir",
    "score": "28 / 50",
    "srank": 10
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "ABHIJNAN MOHANTY",
    "orank": 401,
    "prize": "",
    "roll": "AS196805739",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "23 / 50",
    "srank": 19
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Adyasha Mohapatra",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196805553",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Anwesha Dalai",
    "orank": 401,
    "prize": "",
    "roll": "AS196805505",
    "school": "Lumbini Public School",
    "score": "23/50",
    "srank": 19
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Anwesha Nanda",
    "orank": 178,
    "prize": "",
    "roll": "AS196806338",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "40 / 40",
    "srank": 9
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Anwesha Nanda",
    "orank": 365,
    "prize": "",
    "roll": "AS196805311",
    "school": "Lumbini Public School",
    "score": "25/50",
    "srank": 17
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aradhya Mohanty",
    "orank": 178,
    "prize": "",
    "roll": "AS196805299",
    "school": "Lumbini Public School",
    "score": "40/50",
    "srank": 9
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Avipsa Panda",
    "orank": 301,
    "prize": "",
    "roll": "AS196802345",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "27 / 50",
    "srank": 15
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Baibhav Kumar",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AS196805324",
    "school": "DAV Public School, CSPur",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Baibhavi Bhuyan",
    "orank": 211,
    "prize": "",
    "roll": "AS196805457",
    "school": "DAV Public School, CSPur",
    "score": "35/50",
    "srank": 11
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Baisakhi Mohanty",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AS196805458",
    "school": "KENDRIYA VIDYALAYA NO-1",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Barnali Padhi",
    "orank": 145,
    "prize": "",
    "roll": "AS196805459",
    "school": "KENDRIYA VIDYALAYA NO-1",
    "score": "41/50",
    "srank": 8
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Bhabana ",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196802356",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Bibartan Singh",
    "orank": 365,
    "prize": "",
    "roll": "AS196802351",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 17
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Debashrit Padhihari",
    "orank": 31,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196805460",
    "school": "Kendriya Vidyalaya no-1 Bhubaneswar 1st Shift",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Deshna Ojha",
    "orank": 499,
    "prize": "",
    "roll": "AS196802357",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "15 / 50",
    "srank": 24
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Dev Pradhani ",
    "orank": 199,
    "prize": "",
    "roll": "AS196805461",
    "school": "St.Xavier High School, Satyanagar",
    "score": "39/50",
    "srank": 10
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Deveeshakti Mahala",
    "orank": 23,
    "prize": "School Silver Medal + Special prize",
    "roll": "AS196805462",
    "school": "St.Xavier High School, Satyanagar",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Diljit Patra",
    "orank": 421,
    "prize": "",
    "roll": "AS196802349",
    "school": "Lumbini Public School",
    "score": "23 / 50",
    "srank": 19
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Disha priyadarshini",
    "orank": 401,
    "prize": "",
    "roll": "AS196802542",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "23 / 50",
    "srank": 19
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Divyanshu Bhuyan",
    "orank": 120,
    "prize": "",
    "roll": "AS196805463",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "42/50",
    "srank": 7
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Evlyen Mishra",
    "orank": 99,
    "prize": "",
    "roll": "AS196805464",
    "school": "DAV Public School, Chandrasekharpur, Bhubaneswar-21",
    "score": "44/50",
    "srank": 6
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Harshit Das",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AS196805465",
    "school": "DAV PUBLIC SCHOOL,CHANDRASEKHARPUR,BBSR",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Hitankhi Das",
    "orank": 178,
    "prize": "",
    "roll": "AS196805466",
    "school": "DAV PUBLIC SCHOOL,CHANDRASEKHARPUR,BBSR",
    "score": "40/50",
    "srank": 9
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Hridesh Ray",
    "orank": 333,
    "prize": "",
    "roll": "AS196802546",
    "school": "DAV PUBLIC SCHOOL Chandrasekharpur",
    "score": "26 / 50",
    "srank": 16
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ira Chaudhary",
    "orank": 145,
    "prize": "",
    "roll": "AS196805467",
    "school": "Cohen International",
    "score": "41/50",
    "srank": 8
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Jaykrish Das",
    "orank": 211,
    "prize": "",
    "roll": "AS196805502",
    "school": "Lumbini Public School",
    "score": "35/50",
    "srank": 11
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Jeebtesh Sahoo",
    "orank": 87,
    "prize": "",
    "roll": "AS196805468",
    "school": "Lumbini Public School",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Kaustav Samantaray ",
    "orank": 301,
    "prize": "",
    "roll": "AS196805557",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "27 / 50",
    "srank": 15
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Kirti Kalpa Raja",
    "orank": 99,
    "prize": "",
    "roll": "AS196805469",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "44/50",
    "srank": 6
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Kunal Kaushik",
    "orank": 23,
    "prize": "School Silver Medal + Special prize",
    "roll": "AS196805470",
    "school": "Lumbini Public School",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Lipsa Acharya",
    "orank": 245,
    "prize": "",
    "roll": "AS196805503",
    "school": "Lumbini Public School",
    "score": "32/50",
    "srank": 12
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Maheshi Naik",
    "orank": 387,
    "prize": "",
    "roll": "AS196802350",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "24 / 50",
    "srank": 18
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Manyata Sethi",
    "orank": 265,
    "prize": "",
    "roll": "AS196805501",
    "school": "Lumbini Public School",
    "score": "29/50",
    "srank": 13
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nirnay Bibhudatta",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196805558",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "P. Deeksha",
    "orank": 265,
    "prize": "",
    "roll": "AS196805506",
    "school": "Lumbini Public School",
    "score": "29/50",
    "srank": 13
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Palaksai Mohanty",
    "orank": 451,
    "prize": "",
    "roll": "AS196802346",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "20 / 50",
    "srank": 22
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Pratyanshu Patnaik",
    "orank": 289,
    "prize": "",
    "roll": "AS196802547",
    "school": "DAV Public School cs pur bhubaneswar",
    "score": "28 / 50",
    "srank": 14
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Prayan Ghosh",
    "orank": 289,
    "prize": "",
    "roll": "AS196805552",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "28 / 50",
    "srank": 14
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rihanshi Behera",
    "orank": 387,
    "prize": "",
    "roll": "AS196802360",
    "school": "Lumbini Public School",
    "score": "24 / 50",
    "srank": 18
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rishaan Barick",
    "orank": 436,
    "prize": "",
    "roll": "AS196802358",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "22 / 50",
    "srank": 20
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sanvi Gupta K.",
    "orank": 478,
    "prize": "",
    "roll": "AS196802544",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "16 / 50",
    "srank": 23
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shivam Paital",
    "orank": 333,
    "prize": "",
    "roll": "AS196802354",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "26 / 50",
    "srank": 16
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "SIDDHIMA BEHERA",
    "orank": "",
    "prize": "",
    "roll": "AS196802551",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Smruti Smaranika Pradhan",
    "orank": 437,
    "prize": "",
    "roll": "AS196805500",
    "school": "Kendriya Vidyalaya No. 1, Bhubaneswar",
    "score": "21/50",
    "srank": 21
  },
  {
    "class": "5",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sriya Rani Panda",
    "orank": 245,
    "prize": "",
    "roll": "AS196805504",
    "school": "Lumbini Public School",
    "score": "32/50",
    "srank": 12
  },
  {
    "class": "5",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Adyasha Mohapatra",
    "orank": 69,
    "prize": "School Gold Medal",
    "roll": "SS196805211",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "25 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Anwesha Nanda",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared), Olympiad Gold Medal ",
    "roll": "SS196806101",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "40 / 40",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "ABHIJNAN MOHANTY",
    "orank": 222,
    "prize": "",
    "roll": "AT196805719",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "27 / 50",
    "srank": 14
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Adyasha Mohapatra",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AT196805261",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Aradhya Mohanty",
    "orank": 189,
    "prize": "",
    "roll": "AT196806362",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "37/50",
    "srank": 12
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Avipsa Panda",
    "orank": 222,
    "prize": "",
    "roll": "AT196805256",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "27 / 50",
    "srank": 14
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Baibhav Kumar",
    "orank": 158,
    "prize": "",
    "roll": "AT196805215",
    "school": "DAV Public School, CSPur",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Bibartan Singh",
    "orank": 245,
    "prize": "",
    "roll": "AT196802262",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 15
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Biren Das",
    "orank": 312,
    "prize": "",
    "roll": "AT196805723",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "19 / 50",
    "srank": 19
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Diljit Patra",
    "orank": 269,
    "prize": "",
    "roll": "AT196802260",
    "school": "Lumbini Public School",
    "score": "23 / 50",
    "srank": 17
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Diti Hazari",
    "orank": "",
    "prize": "",
    "roll": "AT196802762",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Hridesh Ray ",
    "orank": "",
    "prize": "",
    "roll": "AT196802759",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Lolla Rudrapriya",
    "orank": 10,
    "prize": "School Silver Medal + Special prize",
    "roll": "AT196805356",
    "school": "Loyola School",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Maheshi Naik",
    "orank": 258,
    "prize": "",
    "roll": "AT196802261",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "24 / 50",
    "srank": 16
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Manisha Mohanta",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AT196805357",
    "school": "KV no.1 bhubaneswer 1st shift",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Mittal Priyadarshi",
    "orank": 135,
    "prize": "",
    "roll": "AT196805358",
    "school": "Cohen International",
    "score": "42/50",
    "srank": 9
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Nakshit Rout",
    "orank": 120,
    "prize": "",
    "roll": "AT196805359",
    "school": "DAV Public School, Garage Chhak",
    "score": "43/50",
    "srank": 8
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Nimisha Sholin Ghadai",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AT196805360",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Noorul Abideen",
    "orank": 172,
    "prize": "",
    "roll": "AT196805361",
    "school": "",
    "score": "40/50",
    "srank": 11
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Palaksai Mohanty",
    "orank": 298,
    "prize": "",
    "roll": "AT196805257",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "20 / 50",
    "srank": 18
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Poonam Pradhan ",
    "orank": 158,
    "prize": "",
    "roll": "AT196805362",
    "school": "Kendriya Vidyalaya No.1 BBSR,Odisha",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Pratyanshu Patnaik",
    "orank": 222,
    "prize": "",
    "roll": "AT196802761",
    "school": "DAV Public School c.s pur",
    "score": "27 / 50",
    "srank": 14
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Prayag Mishra",
    "orank": 99,
    "prize": "",
    "roll": "AT196805363",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Prayan Ghosh",
    "orank": 195,
    "prize": "",
    "roll": "AT196802755",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "28 / 50",
    "srank": 13
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Riaan Rishiraj",
    "orank": 68,
    "prize": "",
    "roll": "AT196805364",
    "school": "Mount Litra Zee School",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Rishav Dash",
    "orank": 158,
    "prize": "",
    "roll": "AT196805365",
    "school": "Mount Litra Zee School",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Saish Nayak",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AT196805366",
    "school": "Mount Litra Zee School",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Saishree Nahak",
    "orank": 10,
    "prize": "School Silver Medal + Special prize",
    "roll": "AT196805367",
    "school": "Mount Litra Zee School",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Saloni Mishra",
    "orank": 21,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AT196805368",
    "school": "Mount Litra Zee School",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Sanchit Kumar Rout",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AT196805369",
    "school": "Cohen International",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Saswat Jagadev",
    "orank": 334,
    "prize": "",
    "roll": "AT196802760",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "19 / 50",
    "srank": 20
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Shriyali Tripathy",
    "orank": 68,
    "prize": "",
    "roll": "AT196805370",
    "school": "Mount Litra Zee School",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "SIDDHIMA BEHERA",
    "orank": "",
    "prize": "",
    "roll": "AT196802763",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Smruti Smaranika Pradhan",
    "orank": 89,
    "prize": "",
    "roll": "AT196805371",
    "school": "Kendriya Vidyalaya No. 1, Bhubaneswar",
    "score": "45/50",
    "srank": 6
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Sumuk Khandual",
    "orank": 99,
    "prize": "",
    "roll": "AT196805372",
    "school": "Mount Litra Zee School",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "5",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Vaibhav Bhuyan",
    "orank": 120,
    "prize": "",
    "roll": "AT196805373",
    "school": "Mount Litra Zee School",
    "score": "43/50",
    "srank": 8
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aadwik Mishra",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196806412",
    "school": "St. Xavier high School, Satyanagar",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Abhijeet  Padhy                                         ",
    "orank": 50,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196806413",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adarsh Kumar Sahoo",
    "orank": 35,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196806414",
    "school": "Cohen International",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aditya Prasad Rajguru",
    "orank": 412,
    "prize": "",
    "roll": "AM196806548",
    "school": "Kendriya vidyalaya no 1",
    "score": "16 / 50",
    "srank": 36
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adityavardhan Patra",
    "orank": 89,
    "prize": "",
    "roll": "AM196806415",
    "school": "Kendriya vidyalaya no 1",
    "score": "45/50",
    "srank": 6
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "ADYA AHWANA SWAIN",
    "orank": "",
    "prize": "",
    "roll": "AM196806556",
    "school": "DAV Public school, CSPur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyanshu Tripathy",
    "orank": 50,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196806416",
    "school": "DAV Public school, CSPur",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aiza Irshad",
    "orank": 146,
    "prize": "",
    "roll": "AM196806417",
    "school": "DAV Public School Cspur",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amandeep Sharma",
    "orank": 135,
    "prize": "",
    "roll": "AM196806418",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "42/50",
    "srank": 9
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amrut Dash",
    "orank": 287,
    "prize": "",
    "roll": "AM196806380",
    "school": "Lumbini Public school",
    "score": "28 / 50",
    "srank": 17
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amruta Rout",
    "orank": 89,
    "prize": "",
    "roll": "AM196806419",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "45/50",
    "srank": 6
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ananya Sar",
    "orank": 102,
    "prize": "",
    "roll": "AM196806420",
    "school": "Lumbini Public school",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anika Sahoo",
    "orank": 121,
    "prize": "",
    "roll": "AM196806421",
    "school": "DAV CHANDRASEKHARPUR",
    "score": "43/50",
    "srank": 8
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anishka Mohapatra",
    "orank": 146,
    "prize": "",
    "roll": "AM196806422",
    "school": "dav chandrasekharpur",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anubha Mishra",
    "orank": 102,
    "prize": "",
    "roll": "AM196806423",
    "school": "Cohen International",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesha Patra",
    "orank": 121,
    "prize": "",
    "roll": "AM196806424",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "43/50",
    "srank": 8
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aparna Sahoo",
    "orank": 146,
    "prize": "",
    "roll": "AM196806425",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Arjun Lenka",
    "orank": 69,
    "prize": "",
    "roll": "AM196806426",
    "school": "St. Xaviers Dist. Centre",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Arnab Beuria",
    "orank": 76,
    "prize": "",
    "roll": "AM196806427",
    "school": "St. Xaviers Dist. Centre",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aryaditya Nayak ",
    "orank": 35,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196806428",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Asmit Mishra",
    "orank": 50,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196806429",
    "school": "Krishnamurthy world school",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Avipsha Acharya",
    "orank": 76,
    "prize": "",
    "roll": "AM196806430",
    "school": "Bal Bharati Public School",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ayush Ranjan Rout",
    "orank": 287,
    "prize": "School Bronze Medal",
    "roll": "AM196806299",
    "school": "DAV Public School, CSPur",
    "score": "28/50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ayushman Behera",
    "orank": 358,
    "prize": "",
    "roll": "AM196806111",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "23 / 50",
    "srank": 25
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ayushman Dash",
    "orank": 102,
    "prize": "",
    "roll": "AM196806431",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bhavyanshi Moulik",
    "orank": 469,
    "prize": "",
    "roll": "AM196806113",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "13 / 50",
    "srank": 39
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bivan Prayash Kalas",
    "orank": 300,
    "prize": "",
    "roll": "AM196806104",
    "school": "Lumbini Public School",
    "score": "27 / 50",
    "srank": 24
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Debarpit Mishra",
    "orank": 235,
    "prize": "",
    "roll": "AM196806550",
    "school": "Kendriya Vidyalaya no-1 Bhubaneswar Shift 1",
    "score": "33 / 50",
    "srank": 11
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Devraj Senapati",
    "orank": 311,
    "prize": "",
    "roll": "AM196806390",
    "school": "St.Xavier High School, Satyanagar",
    "score": "26 / 50",
    "srank": 31
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Divyanka Kumari",
    "orank": 287,
    "prize": "",
    "roll": "AM196806108",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "28 / 50",
    "srank": 17
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Farzeen Fatema",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196806110",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Gaurav Rout",
    "orank": 278,
    "prize": "School Silver Medal",
    "roll": "AM196806501",
    "school": "DAV Public School, CSPur",
    "score": "30/50",
    "srank": 2
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "GIRIJA NANDINI RAUTARAY",
    "orank": 325,
    "prize": "",
    "roll": "AM196806389",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "25 / 50",
    "srank": 35
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Hridoy Barik",
    "orank": 245,
    "prize": "School Gold Medal",
    "roll": "AM196806500",
    "school": "DAV Public School, CSPur",
    "score": "32/50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jeet Aditeya Dash",
    "orank": 371,
    "prize": "",
    "roll": "AM196806107",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "22 / 50",
    "srank": 28
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Lokesh Bhuyan",
    "orank": 269,
    "prize": "",
    "roll": "AM196802660",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 50",
    "srank": 14
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "OM KRISHAN DEV",
    "orank": "",
    "prize": "",
    "roll": "AM196806544",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Pratyusha Sahoo",
    "orank": 287,
    "prize": "",
    "roll": "AM196806112",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "28 / 50",
    "srank": 17
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "R.Trishika",
    "orank": 371,
    "prize": "",
    "roll": "AM196806388",
    "school": "Kendriya vidyala number 1 bhubaneswar",
    "score": "22 / 50",
    "srank": 28
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "S. Omkar Animesh Bal",
    "orank": 399,
    "prize": "",
    "roll": "AM196805098",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "18 / 50",
    "srank": 32
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Saanvi sethi",
    "orank": 469,
    "prize": "",
    "roll": "AM196806376",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "13/50",
    "srank": 39
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "SAHARSH PATTANAIK",
    "orank": 444,
    "prize": "",
    "roll": "AM196806384",
    "school": "Mother's public school khandagiri",
    "score": "15 / 50",
    "srank": 37
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "SAI PARTHASARATHI NAYAK",
    "orank": 287,
    "prize": "",
    "roll": "AM196806375",
    "school": "DAV PUBLIC SCHOOL, C S PUR, BHUBANESWAR",
    "score": "28 / 50",
    "srank": 17
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai Stuti",
    "orank": 389,
    "prize": "",
    "roll": "AM196806100",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "20 / 50",
    "srank": 31
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sanket Behera",
    "orank": 287,
    "prize": "",
    "roll": "AM196806378",
    "school": "Kendriya vidyalaya no -1, Bhubaneswar",
    "score": "28 / 50",
    "srank": 17
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sartaz khan",
    "orank": 345,
    "prize": "",
    "roll": "AM196806379",
    "school": "Kendriya vidyalaya",
    "score": "24 / 50",
    "srank": 21
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "sarthak joshi",
    "orank": 269,
    "prize": "",
    "roll": "AM196806377",
    "school": "home school",
    "score": "29 / 50",
    "srank": 14
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "SHIVNARAYAN PANDA",
    "orank": 410,
    "prize": "",
    "roll": "AM196806387",
    "school": "KENDRIYA BIDYALAYA-1",
    "score": "17 / 50",
    "srank": 35
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shradha Suman Samal",
    "orank": 287,
    "prize": "",
    "roll": "AM196806383",
    "school": "Kendriya vidyalaya no 3",
    "score": "28 / 50",
    "srank": 17
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shubhechha Ghosh",
    "orank": 358,
    "prize": "",
    "roll": "AM196806386",
    "school": "Dav Public school",
    "score": "23 / 50",
    "srank": 25
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sibanshi Acharya",
    "orank": 345,
    "prize": "",
    "roll": "AM196806109",
    "school": "Lumbini Public School",
    "score": "24 / 50",
    "srank": 21
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Snehashish Panda",
    "orank": 371,
    "prize": "",
    "roll": "AM196806102",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "22 / 50",
    "srank": 28
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Stiti Pragyan Behera",
    "orank": 325,
    "prize": "",
    "roll": "AM196806385",
    "school": "DAV Public School",
    "score": "25 / 50",
    "srank": 35
  },
  {
    "class": "6",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Swayam Mohapatra",
    "orank": 311,
    "prize": "",
    "roll": "AM196805099",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "26 / 50",
    "srank": 31
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "ADYA AHWANA SWAIN",
    "orank": "",
    "prize": "",
    "roll": "AR196806559",
    "school": "DAV Public school, CSPur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ayush Ranjan Rout",
    "orank": 101,
    "prize": "School Gold Medal",
    "roll": "AR196806257",
    "school": "DAV Public School cs pur Bhubaneswar",
    "score": "40/50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Bivan Prayash Kalas",
    "orank": 222,
    "prize": "",
    "roll": "AR196806264",
    "school": "Lumbini Public School",
    "score": "27 / 50",
    "srank": 15
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Chiranjeet Bhakta",
    "orank": 31,
    "prize": "Special Prize",
    "roll": "AR196806357",
    "school": "Dav cspur, bbsr",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Choudhury Subham Nanda",
    "orank": 102,
    "prize": "",
    "roll": "AR196806358",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Daanish Rahman",
    "orank": 25,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196806359",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Debeesmita Lenka",
    "orank": 11,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196806360",
    "school": "Kendriya Vidyalaya no-1 Bhubaneswar 1st Shift",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Deval Bal ",
    "orank": 102,
    "prize": "",
    "roll": "AR196806361",
    "school": "St.Xavier High School, Satyanagar",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "DEVRAJ SENAPATI",
    "orank": "",
    "prize": "",
    "roll": "AR196806642",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Deyaan Das",
    "orank": 178,
    "prize": "",
    "roll": "AR196806362",
    "school": "",
    "score": "39/50",
    "srank": 11
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Dibyanshu Sekhar Nayak",
    "orank": 136,
    "prize": "",
    "roll": "AR196806363",
    "school": "Kendriya Vidyalaya no-1 2nd shift bhubaneswar",
    "score": "41/50",
    "srank": 8
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Divyanka Kumari",
    "orank": 201,
    "prize": "",
    "roll": "AR196806268",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "28 / 50",
    "srank": 14
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Divyansh Mishra",
    "orank": 159,
    "prize": "",
    "roll": "AR196806364",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "40/50",
    "srank": 9
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Divyanshu Mohanty",
    "orank": 89,
    "prize": "",
    "roll": "AR196806365",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "45/50",
    "srank": 6
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Gaurav Rout",
    "orank": 102,
    "prize": "",
    "roll": "AR196806366",
    "school": "DAV Public School, CSPur",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "GIRIJA NANDINI RAUTARAY",
    "orank": 258,
    "prize": "",
    "roll": "AR196806638",
    "school": "K.V NO.1 BBSR",
    "score": "25 / 50",
    "srank": 17
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Hridoy Barik",
    "orank": 289,
    "prize": "",
    "roll": "AR196806639",
    "school": "DAV public school ,Cspur BBSR",
    "score": "23 / 50",
    "srank": 18
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ishan Swain",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AR196806367",
    "school": "Cohen International",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Jeet Aditeya Dash",
    "orank": 301,
    "prize": "",
    "roll": "AR196806267",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "22 / 50",
    "srank": 19
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Jivitesh Jena",
    "orank": 25,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196806368",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Kirti Vedant Das",
    "orank": 11,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196806369",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Laksh Agarwal",
    "orank": 102,
    "prize": "",
    "roll": "AR196806370",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Lipsa Acharya",
    "orank": 188,
    "prize": "",
    "roll": "AR196806898",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "37 / 50",
    "srank": 12
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Luiston Nayak",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196806371",
    "school": "Loyola School",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Manshraj Kalo",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AR196806372",
    "school": "Lumbini Public School",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "S. Omkar Animesh Bal",
    "orank": 365,
    "prize": "",
    "roll": "AR196806258",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "18 / 50",
    "srank": 22
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Saharsh Pattanaik ",
    "orank": 191,
    "prize": "",
    "roll": "AR196806640",
    "school": "St. Xavier high School, Satyanagar",
    "score": "35/50",
    "srank": 13
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sai Stuti",
    "orank": 336,
    "prize": "",
    "roll": "AR196806260",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "20 / 50",
    "srank": 21
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sarthak Joshi",
    "orank": 222,
    "prize": "",
    "roll": "AR196806637",
    "school": "Home school",
    "score": "27 / 50",
    "srank": 15
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Shreyanvi Satapathy",
    "orank": 321,
    "prize": "",
    "roll": "AR196806641",
    "school": "DAV PUBLIC SCHOOL C S PUR CAMPUS 2",
    "score": "21 / 50",
    "srank": 20
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Snehashish Panda",
    "orank": 301,
    "prize": "",
    "roll": "AR196806262",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "22 / 50",
    "srank": 19
  },
  {
    "class": "6",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Swayam Mohapatra",
    "orank": 245,
    "prize": "",
    "roll": "AR196806259",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "26 / 50",
    "srank": 16
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aditya Prasad Rajguru",
    "orank": 411,
    "prize": "",
    "roll": "AS196806561",
    "school": "Kendriya vidyalaya no 1",
    "score": "11 /.40",
    "srank": 31
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "ADYA AHWANA SWAIN",
    "orank": "",
    "prize": "",
    "roll": "AS196806568",
    "school": "DAV Public school, CSPur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "AMRUTHA SAHOO",
    "orank": "",
    "prize": "",
    "roll": "AS196806552",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Avilipsha priyadarshee",
    "orank": 300,
    "prize": "",
    "roll": "AS196806556",
    "school": "Kendriya vidyalaya no.1 bbsr",
    "score": "22 / 40",
    "srank": 26
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ayush Ranjan Rout",
    "orank": 156,
    "prize": "",
    "roll": "AS196806395",
    "school": "DAV Public school chandrasekharpur BBSR Odisha",
    "score": "35/50",
    "srank": 2
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ayushman Behera",
    "orank": 275,
    "prize": "",
    "roll": "AS196806250",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "23 / 50",
    "srank": 25
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Bhavyanshi Moulik",
    "orank": 399,
    "prize": "",
    "roll": "AS196806232",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "13 / 50",
    "srank": 30
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Bivan Prayash Kalas",
    "orank": 201,
    "prize": "",
    "roll": "AS196806223",
    "school": "Lumbini Public School",
    "score": "27 / 50",
    "srank": 21
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Debarpit Mishra",
    "orank": 339,
    "prize": "",
    "roll": "AS196806570",
    "school": "Kendriya Vidyalaya no-1 Bhubaneswar 1st Shift",
    "score": "21 / 40",
    "srank": 27
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Devraj Senapati",
    "orank": 300,
    "prize": "",
    "roll": "AS196806521",
    "school": "St. Xavier high School, Satyanagar",
    "score": "22 / 50",
    "srank": 26
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Divyanka Kumari",
    "orank": 189,
    "prize": "",
    "roll": "AS196806227",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "28 / 50",
    "srank": 19
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Farzeen Fatema",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196806229",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Hridoy Barik",
    "orank": 246,
    "prize": "",
    "roll": "AS196806518",
    "school": "DAV public school",
    "score": "24 / 50",
    "srank": 24
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Jeet Aditeya Dash",
    "orank": 300,
    "prize": "",
    "roll": "AS196806226",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "22 / 50",
    "srank": 26
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Lokesh Bhuyan",
    "orank": 178,
    "prize": "",
    "roll": "AS196802348",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 50",
    "srank": 18
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Mohit Bisoyi",
    "orank": 75,
    "prize": "",
    "roll": "AS196806495",
    "school": "Cohen International",
    "score": "41/50",
    "srank": 9
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Mokshita Das",
    "orank": 114,
    "prize": "School Gold Medal",
    "roll": "AS196806396",
    "school": "DAV Public school chandrasekharpur BBSR Odisha",
    "score": "39/50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Monal Mohanty",
    "orank": 57,
    "prize": "",
    "roll": "AS196806496",
    "school": "DAV Public School, Garage Chhak",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Naman Mishra",
    "orank": 156,
    "prize": "",
    "roll": "AS196806497",
    "school": "DAV Public School, Garage Chhak",
    "score": "35/50",
    "srank": 17
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nirbikar Rout",
    "orank": 98,
    "prize": "",
    "roll": "AS196806498",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "40/50",
    "srank": 10
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Om Amrit Mohanty",
    "orank": 135,
    "prize": "",
    "roll": "AS196806499",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "36/50",
    "srank": 14
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "OM KRISHAN DEV",
    "orank": "",
    "prize": "",
    "roll": "AS196806557",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Padmaja Prajna Parida",
    "orank": 75,
    "prize": "",
    "roll": "AS196806500",
    "school": "DAV PUBLIC SCHOOL CS PUR",
    "score": "41/50",
    "srank": 9
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Pratyasha Pal ",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AS196806501",
    "school": "Cohen International",
    "score": "45/50",
    "srank": 6
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Pratyusha Sahoo",
    "orank": 189,
    "prize": "",
    "roll": "AS196806231",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "28 / 50",
    "srank": 19
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Pritiparna Panda",
    "orank": 9,
    "prize": "School Silver Medal + Special prize",
    "roll": "AS196806502",
    "school": "KENDRIYA VIDYALAYA NO-1 (2ND SHIFT ) BHUBANESWAR",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "S. Omkar Animesh Bal",
    "orank": 385,
    "prize": "",
    "roll": "AS196806217",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "18 / 50",
    "srank": 29
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "SAI PARTHASARATHI NAYAK",
    "orank": 349,
    "prize": "",
    "roll": "AS196806515",
    "school": "DAV PUBLIC SCHOOL, CSPUR, BHUBANESWAR",
    "score": "20 / 50",
    "srank": 28
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai Stuti",
    "orank": 349,
    "prize": "",
    "roll": "AS196806219",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "20 / 50",
    "srank": 28
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Samrat Singh Kauntai",
    "orank": 15,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196806503",
    "school": "Mount Litra Zee School",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sanchit Shuvam Behera",
    "orank": 18,
    "prize": "Special Prize",
    "roll": "AS196806504",
    "school": "Cohen International",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sarthak joshi",
    "orank": 234,
    "prize": "",
    "roll": "AS196806514",
    "school": "Home school",
    "score": "26 / 50",
    "srank": 22
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shivnarayan panda",
    "orank": 300,
    "prize": "",
    "roll": "AS196806516",
    "school": "Kendriyavidyalaya no-1,BBSR",
    "score": "22 / 50",
    "srank": 26
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shreyansh Baral",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AS196806505",
    "school": "Kendriya vidyalaya no 6",
    "score": "45/50",
    "srank": 6
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shreyanvi Satapathy",
    "orank": 246,
    "prize": "",
    "roll": "AS196806519",
    "school": "DAV PUBLIC SCHOOL CHANDRASEKHAR PUR",
    "score": "24 / 50",
    "srank": 24
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shrivalli Mishra",
    "orank": 135,
    "prize": "",
    "roll": "AS196806506",
    "school": "Mount Litra Zee School",
    "score": "36/50",
    "srank": 13
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shubhechha Ghosh",
    "orank": 275,
    "prize": "",
    "roll": "AS196806520",
    "school": "DAV Public school",
    "score": "23 / 50",
    "srank": 25
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sibanshi Acharya",
    "orank": 246,
    "prize": "",
    "roll": "AS196806228",
    "school": "Lumbini Public School",
    "score": "24 / 50",
    "srank": 24
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Smarak Das ",
    "orank": 59,
    "prize": "",
    "roll": "AS196806507",
    "school": "Mount Litra Zee School",
    "score": "42/50",
    "srank": 8
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Snehashish Panda",
    "orank": 300,
    "prize": "",
    "roll": "AS196806221",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "22 / 50",
    "srank": 26
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Soubhagya Ranjan Biswal",
    "orank": 114,
    "prize": "",
    "roll": "AS196806508",
    "school": "Mount Litra Zee School",
    "score": "39/50",
    "srank": 11
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Suvdeep Choudhury ",
    "orank": 98,
    "prize": "",
    "roll": "AS196806509",
    "school": "Mount Litra Zee School",
    "score": "40/50",
    "srank": 10
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Swayam Mohapatra",
    "orank": 234,
    "prize": "",
    "roll": "AS196806218",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "26 / 50",
    "srank": 22
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Swayam Nanda",
    "orank": 15,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196806510",
    "school": "DAV Public School Chandrasekharpur",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Swayam Prakash Pani",
    "orank": 75,
    "prize": "",
    "roll": "AS196806511",
    "school": "DAV Public School Chandrasekharpur",
    "score": "41/50",
    "srank": 9
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Swayam Sankalp Behera",
    "orank": 31,
    "prize": "Special Prize",
    "roll": "AS196806512",
    "school": "DAV Public School Chandrasekharpur",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "TEERTHANSHU",
    "orank": 246,
    "prize": "",
    "roll": "AM196806513",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "24 / 50",
    "srank": 24
  },
  {
    "class": "6",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Yashraj Jayasingh",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196806513",
    "school": "Mount Litra Zee School",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Ayush Ranjan Rout",
    "orank": 98,
    "prize": "School Gold Medal",
    "roll": "SS196806129",
    "school": "DAV Public school chandrasekharpur BBSR Odisha",
    "score": "37/45",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Ayushman Behera",
    "orank": 189,
    "prize": "",
    "roll": "SS196806046",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "23 / 50",
    "srank": 6
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Bhavyanshi Moulik",
    "orank": 189,
    "prize": "",
    "roll": "SS196806048",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "23 / 50",
    "srank": 6
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "DEVRAJ SENAPATI",
    "orank": "",
    "prize": "",
    "roll": "SS196806092",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Farzeen Fatema",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared), Olympiad Gold Medal ",
    "roll": "SS196806045",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Mokshita Das",
    "orank": 102,
    "prize": "School Silver Medal",
    "roll": "SS196806131",
    "school": "DAV Public school chandrasekharpur BBSR Odisha",
    "score": "35/45",
    "srank": 2
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Nikhil Jeet Behera",
    "orank": 169,
    "prize": "",
    "roll": "SS196806089",
    "school": "Kendriya Vidyalaya no. 1, Bhubaneswar",
    "score": "26 / 50",
    "srank": 5
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Pratyusha Sahoo",
    "orank": 230,
    "prize": "",
    "roll": "SS196806047",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "18 / 50",
    "srank": 9
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Saharsh Pattanaik",
    "orank": 124,
    "prize": "School Bronze Medal",
    "roll": "SS196806093",
    "school": "Mothers public school Khandagiri",
    "score": "29 / 50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Sarthak Joshi",
    "orank": 154,
    "prize": "",
    "roll": "SS196806090",
    "school": "Homeschool",
    "score": "27 / 50",
    "srank": 4
  },
  {
    "class": "6",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Shubhechha Ghosh",
    "orank": 199,
    "prize": "",
    "roll": "SS196806094",
    "school": "Dav Public school",
    "score": "22 / 50",
    "srank": 8
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "ADYA AHWANA SWAIN",
    "orank": "",
    "prize": "",
    "roll": "AT196806788",
    "school": "DAV Public school, CSPur",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Ayush Ranjan Rout",
    "orank": 175,
    "prize": "School Silver Medal ",
    "roll": "AT196806325",
    "school": "DAV PUBLIC SCHOOL,CHANDRASEKHARPUR,BBSR",
    "score": "40/50",
    "srank": 2
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Ayushman Behera",
    "orank": 169,
    "prize": "",
    "roll": "AT196803563",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "23 / 50",
    "srank": 8
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "BISHWA RANJAN PARIDA",
    "orank": 202,
    "prize": "",
    "roll": "AT196806781",
    "school": "DAV PUBLIC SCHOOL UNIT-VIII BHUBANESWAR",
    "score": "13 / 50",
    "srank": 12
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Bivan Prayash Kalas",
    "orank": 145,
    "prize": "",
    "roll": "AT196806556",
    "school": "Lumbini Public School",
    "score": "27 / 50",
    "srank": 6
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "BONGAM DURGA HEMBRAM",
    "orank": "",
    "prize": "",
    "roll": "AT196803703",
    "school": "Mother's public school khandagiri",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "DEVRAJ SENAPATI",
    "orank": "",
    "prize": "",
    "roll": "AT196803709",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Divyanka Kumari",
    "orank": 123,
    "prize": "",
    "roll": "AT196803560",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "28 / 50",
    "srank": 5
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Eliska Haro",
    "orank": 222,
    "prize": "",
    "roll": "AT196806783",
    "school": "kendriya Vidyalaya no 1",
    "score": "Aug-50",
    "srank": 13
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Farzeen Fatema",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AT196803562",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "GIRIJA NANDINI RAUTARAY",
    "orank": 101,
    "prize": "",
    "roll": "AT196803704",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "29 / 50",
    "srank": 4
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Hridoy Barik",
    "orank": 156,
    "prize": "School Gold Medal ",
    "roll": "AT196806326",
    "school": "DAV PUBLIC SCHOOL,CHANDRASEKHARPUR,BBSR",
    "score": "42/50",
    "srank": 1
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Jeet Aditeya Dash",
    "orank": 189,
    "prize": "",
    "roll": "AT196806559",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "22 / 50",
    "srank": 9
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Lipsa Acharya",
    "orank": 89,
    "prize": "School Bronze Medal",
    "roll": "AT196806358",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "37 / 50",
    "srank": 3
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Lokesh Bhuyan",
    "orank": 101,
    "prize": "",
    "roll": "AT196806259",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 50",
    "srank": 4
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "SAHARSH PATTANAIK",
    "orank": 200,
    "prize": "",
    "roll": "AT196803706",
    "school": "Mother's public school khandagiri",
    "score": "18 / 50",
    "srank": 11
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "SAI PARTHASARATHI NAYAK",
    "orank": 158,
    "prize": "",
    "roll": "at196803701",
    "school": "DAV PUBLIC SCHOOL, CSPUR, BHUBANESWAR",
    "score": "25 / 50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "sarthak joshi",
    "orank": 123,
    "prize": "",
    "roll": "AT196803702",
    "school": "home school",
    "score": "28 / 50",
    "srank": 5
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Shreyanvi Satapathy",
    "orank": 158,
    "prize": "",
    "roll": "AT196803707",
    "school": "DAV PUBLIC SCHOOL C S PUR CAMPUS 2",
    "score": "25 / 50",
    "srank": 7
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Shubhechha Ghosh",
    "orank": 123,
    "prize": "",
    "roll": "AT196803708",
    "school": "DAV Public school Chandrasekharpur",
    "score": "28 / 50",
    "srank": 5
  },
  {
    "class": "6",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Sibanshi Acharya",
    "orank": 199,
    "prize": "",
    "roll": "AT196803561",
    "school": "Lumbini Public School",
    "score": "20 / 50",
    "srank": 10
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Akshyat Aadit Sahu",
    "orank": 315,
    "prize": "",
    "roll": "AM196804433",
    "school": "DAV Public School Cspur",
    "score": "25 / 50",
    "srank": 74
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amrita Pani",
    "orank": 251,
    "prize": "",
    "roll": "AM196807599",
    "school": "KV No.1 BBSR,2ND SHIFT",
    "score": "32 / 50",
    "srank": 63
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesh priyanshu Das",
    "orank": "",
    "prize": "",
    "roll": "AM196807603",
    "school": "Cohen International",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aratrika Bhuyan",
    "orank": 361,
    "prize": "",
    "roll": "AM196804108",
    "school": "Lumbini Public School",
    "score": "20 / 50",
    "srank": 88
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Asmin kumar sahoo",
    "orank": 401,
    "prize": "",
    "roll": "AM196804432",
    "school": "Kendriya vidyalaya no-1bhubaneswer",
    "score": "14 / 50",
    "srank": 93
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bahumanya Prusty",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196807335",
    "school": "DAV Public School, CSPur",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bedavyash Jena ",
    "orank": "",
    "prize": "",
    "roll": "AM196804434",
    "school": "KENDRIYA VIDYALAYA NO-1",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bhagyalaxmi Sahoo",
    "orank": 235,
    "prize": "",
    "roll": "AM196807426",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "39 / 50",
    "srank": 59
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bhumika",
    "orank": 378,
    "prize": "",
    "roll": "AM196804443",
    "school": "Dav public school cspur",
    "score": "16 / 50",
    "srank": 90
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "D. Reansh",
    "orank": 147,
    "prize": "",
    "roll": "AM196807304",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "45/50",
    "srank": 35
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "D. Shwetank",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196807305",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Debabrata Das",
    "orank": 75,
    "prize": "",
    "roll": "AM196807306",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "48/50",
    "srank": 15
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Debesh Mishra",
    "orank": 245,
    "prize": "",
    "roll": "AM196807425",
    "school": "DAV PUBLIC SCHOOL UNIT - 8 BBSR",
    "score": "35 / 50",
    "srank": 61
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Debesh Pattnaik",
    "orank": 34,
    "prize": "Special Prize",
    "roll": "AM196807307",
    "school": "DAV PUBLIC SCHOOL UNIT - 8 BBSR",
    "score": "49/50",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Devansh Bhol",
    "orank": 159,
    "prize": "",
    "roll": "AM196807308",
    "school": "St.Xavier High School, Satyanagar",
    "score": "44/50",
    "srank": 41
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dibyachetan Parhi",
    "orank": 125,
    "prize": "",
    "roll": "AM196807309",
    "school": "DAV public School Chandrasekharpur",
    "score": "47/50",
    "srank": 24
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dibyasha Samal",
    "orank": 147,
    "prize": "",
    "roll": "AM196807310",
    "school": "Kendriya Vidyalaya no-1 2nd shift bhubaneswar",
    "score": "45/50",
    "srank": 35
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Diksha Debanshi Baral",
    "orank": 284,
    "prize": "",
    "roll": "AM196804421",
    "school": "Kendriya Vidyalaya no-1 2nd shift bhubaneswar",
    "score": "28 / 50",
    "srank": 65
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Divyansh Behera",
    "orank": 174,
    "prize": "",
    "roll": "AM196807311",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "43/50",
    "srank": 45
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dona Pradhan",
    "orank": 219,
    "prize": "",
    "roll": "AM196807312",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "40/50",
    "srank": 53
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Gaurish Hari Jena",
    "orank": 125,
    "prize": "",
    "roll": "AM196807313",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "47/50",
    "srank": 24
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Goutami Saishradha Biswal",
    "orank": 291,
    "prize": "",
    "roll": "AM196804435",
    "school": "D.A.V. Public School",
    "score": "27 / 50",
    "srank": 67
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Hitesh Gupta",
    "orank": 219,
    "prize": "",
    "roll": "AM196807314",
    "school": "DAV PUBLIC SCHOOL,CHANDRASEKHARPUR,BBSR",
    "score": "40/50",
    "srank": 53
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ishaan Mohanty",
    "orank": 201,
    "prize": "",
    "roll": "AM196807315",
    "school": "Cohen International",
    "score": "41/50",
    "srank": 51
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ishan Verma",
    "orank": 159,
    "prize": "",
    "roll": "AM196807316",
    "school": "Cohen International",
    "score": "44/50",
    "srank": 41
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ismit Tripathy",
    "orank": 34,
    "prize": "Special Prize",
    "roll": "AM196807317",
    "school": "Cohen International",
    "score": "49/50",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jigyansa Mohanty",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196804105",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jyosrit Jayshivam ",
    "orank": 75,
    "prize": "",
    "roll": "AM196807318",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "48/50",
    "srank": 15
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Komal Krishna",
    "orank": 235,
    "prize": "",
    "roll": "AM196807319",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "39/50",
    "srank": 59
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Labdhi Swain",
    "orank": 284,
    "prize": "",
    "roll": "AM196804426",
    "school": "Kendriyla Vidylaya",
    "score": "28 / 50",
    "srank": 65
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Maanvik Jayprakas",
    "orank": 201,
    "prize": "",
    "roll": "AM196807320",
    "school": "Loyola School",
    "score": "41/50",
    "srank": 51
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Manushree Pati",
    "orank": 183,
    "prize": "",
    "roll": "AM196807321",
    "school": "Lumbini Public School",
    "score": "42/50",
    "srank": 49
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Mayank Kumar Singh",
    "orank": 345,
    "prize": "",
    "roll": "AM196804112",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "22 / 50",
    "srank": 82
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Mohit Digal",
    "orank": 135,
    "prize": "",
    "roll": "AM196807322",
    "school": "Cohen International",
    "score": "46/50",
    "srank": 27
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Monalisha Sahoo",
    "orank": 125,
    "prize": "",
    "roll": "AM196807323",
    "school": "DAV Public School, Garage Chhak",
    "score": "47/50",
    "srank": 24
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Namya Swain",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196804107",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Navya Behera",
    "orank": 174,
    "prize": "",
    "roll": "AM196807324",
    "school": "DAV Public School, Garage Chhak",
    "score": "43/50",
    "srank": 45
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Nirjhara Sahoo",
    "orank": 75,
    "prize": "",
    "roll": "AM196807325",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "48/50",
    "srank": 15
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Om Prakash Kar",
    "orank": 174,
    "prize": "",
    "roll": "AM196807326",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "43/50",
    "srank": 45
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Padmajaya Swain",
    "orank": 159,
    "prize": "",
    "roll": "AM196807327",
    "school": "DAV PUBLIC SCHOOL CS PUR",
    "score": "44/50",
    "srank": 41
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Pratyush Kumar Sahoo",
    "orank": 201,
    "prize": "",
    "roll": "AM196807328",
    "school": "Cohen International",
    "score": "41/50",
    "srank": 51
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Pratyush Panigrahi",
    "orank": 183,
    "prize": "",
    "roll": "AM196807329",
    "school": "",
    "score": "42/50",
    "srank": 49
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Pratyush Panigrahi",
    "orank": 378,
    "prize": "",
    "roll": "AM196804436",
    "school": "Dav public school",
    "score": "16 / 50",
    "srank": 90
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Prayag Kumar Swain",
    "orank": 34,
    "prize": "Special Prize",
    "roll": "AM196807330",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "49/50",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Priyabrata Behera",
    "orank": 291,
    "prize": "",
    "roll": "AM196804104",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "27 / 50",
    "srank": 67
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rajkanya Swain",
    "orank": 369,
    "prize": "",
    "roll": "AM196804110",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "19 / 50",
    "srank": 89
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ritisha Mohapatra",
    "orank": 352,
    "prize": "",
    "roll": "AM196804437",
    "school": "DAV CSPUR BBSR",
    "score": "21 / 50",
    "srank": 85
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Roshni Ruhansika Panda",
    "orank": 301,
    "prize": "",
    "roll": "AM196804113",
    "school": "Lumbini Public School",
    "score": "26 / 50",
    "srank": 69
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rudra prakash dash",
    "orank": "",
    "prize": "",
    "roll": "AM196804422",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Saanvi Parida",
    "orank": 335,
    "prize": "",
    "roll": "AM196807604",
    "school": "Kenriya Vidyalaya No.1",
    "score": "23 / 50",
    "srank": 79
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai anantika dash",
    "orank": 256,
    "prize": "",
    "roll": "AM196807601",
    "school": "Kendriya vidyalaya no 1",
    "score": "29 / 50",
    "srank": 64
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "sai prasad mishra",
    "orank": 321,
    "prize": "",
    "roll": "AM196807598",
    "school": "kendriya vidyala no.1",
    "score": "24 / 50",
    "srank": 77
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Saisampurna Behera",
    "orank": 284,
    "prize": "",
    "roll": "AM196804111",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "28 / 50",
    "srank": 65
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Saishree Pattanayak",
    "orank": 75,
    "prize": "",
    "roll": "AM196807331",
    "school": "Mount Litra Zee School",
    "score": "48/50",
    "srank": 15
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Saismita Dash",
    "orank": 125,
    "prize": "",
    "roll": "AM196807332",
    "school": "Mount Litra Zee School",
    "score": "47/50",
    "srank": 24
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sambhavi Nanda",
    "orank": 75,
    "prize": "",
    "roll": "AM196807333",
    "school": "Mount Litra Zee School",
    "score": "48/50",
    "srank": 15
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Samikshya Dalai",
    "orank": "",
    "prize": "",
    "roll": "AM196804438",
    "school": "DAV Public school",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sanskruti Mohanty Mohapatra",
    "orank": 284,
    "prize": "",
    "roll": "AM196804442",
    "school": "Kendriya Vidyalaya no 1, 2nd shift, BBSR",
    "score": "28 / 50",
    "srank": 65
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sattvik Sarangi",
    "orank": "",
    "prize": "",
    "roll": "AM196804439",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Soumya Ranjan sahoo",
    "orank": 132,
    "prize": "",
    "roll": "AT196803398",
    "school": "Kendriya vidyalaya",
    "score": "26 / 50",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Subhra",
    "orank": 315,
    "prize": "",
    "roll": "AM196804103",
    "school": "Lumbini Public School",
    "score": "25 / 50",
    "srank": 74
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Subhransu Sekhar Moharana",
    "orank": 345,
    "prize": "",
    "roll": "AM196804441",
    "school": "Kendriya Vidyalaya No.1,Bhebaneswar",
    "score": "22 / 50",
    "srank": 82
  },
  {
    "class": "7",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Swastik Mohanty",
    "orank": 284,
    "prize": "",
    "roll": "AM196804440",
    "school": "DAV PUBLIC SCHOOL CHANDRASEKHARPUR",
    "score": "28 / 50",
    "srank": 65
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aaeshanee Mishra",
    "orank": 291,
    "prize": "",
    "roll": "AR196807764",
    "school": "Kendriya Vidyalaya number 1 Bhubaneswar",
    "score": "21 / 50",
    "srank": 23
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aarish Patra",
    "orank": 15,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196807500",
    "school": "St. Xaviers International",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aarvi Satapathy ",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "AR196807501",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Adarsh Jena",
    "orank": 121,
    "prize": "",
    "roll": "AR196807502",
    "school": "Cohen International",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "ADITI ADYASHA MOHAPATRA",
    "orank": 230,
    "prize": "",
    "roll": "AR196807763",
    "school": "KENDRIYA VIDYALAYA NUMBER- 01, UNIT -IX, BHOI NAGAR, BHUBANESWAR",
    "score": "26 / 50",
    "srank": 19
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Adyasha Anurita",
    "orank": 79,
    "prize": "",
    "roll": "AR196807503",
    "school": "DAV Public school, CSPur",
    "score": "43/50",
    "srank": 8
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Adyashree Pradhan",
    "orank": 41,
    "prize": "Special Prize",
    "roll": "AR196807504",
    "school": "Kendriya vidyalaya no. 1, bbsr",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Akshat Kandpal",
    "orank": 9,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196807505",
    "school": "DAV Public School Cspur",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Amitabh Jena",
    "orank": 169,
    "prize": "",
    "roll": "AR196807506",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "38/50",
    "srank": 14
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Anamitra Sankar",
    "orank": 121,
    "prize": "",
    "roll": "AR196807507",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Aratrika Bhuyan",
    "orank": 301,
    "prize": "",
    "roll": "AR196804409",
    "school": "Lumbini Public School",
    "score": "20 / 50",
    "srank": 24
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Bhagyalaxmi Sahoo",
    "orank": 148,
    "prize": "",
    "roll": "AR196807413",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "39 / 50",
    "srank": 13
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Dibyansa Mohanty",
    "orank": 187,
    "prize": "",
    "roll": "AR196804407",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 50",
    "srank": 15
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Jigyansa Mohanty",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196804406",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Labdhi Swain",
    "orank": 256,
    "prize": "",
    "roll": "AR196804599",
    "school": "Kendriya Vidylaya No 1",
    "score": "23 / 50",
    "srank": 21
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Mayank Kumar Singh",
    "orank": 269,
    "prize": "",
    "roll": "AR196804413",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "22 / 50",
    "srank": 22
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Namya Swain",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196804408",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Pratyush Panigrahi",
    "orank": 365,
    "prize": "",
    "roll": "AR196804603",
    "school": "DAV Public School",
    "score": "18 / 50",
    "srank": 26
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Rajkanya Swain",
    "orank": 321,
    "prize": "",
    "roll": "AR196804411",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "19 / 50",
    "srank": 25
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "RITISHA MOHAPATRA",
    "orank": 321,
    "prize": "",
    "roll": "AR196804604",
    "school": "DAV CS PUR BBSR",
    "score": "19 / 50",
    "srank": 25
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Roshni Ruhansika Panda",
    "orank": 230,
    "prize": "",
    "roll": "AR196804414",
    "school": "Lumbini Public School",
    "score": "26 / 50",
    "srank": 19
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Saieesha Mishra",
    "orank": 394,
    "prize": "",
    "roll": "AR196804600",
    "school": "Kendriya vidyalaya no.1 BBSR",
    "score": "Nov-50",
    "srank": 27
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Saisampurna Behera",
    "orank": 201,
    "prize": "",
    "roll": "AR196807412",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "28 / 50",
    "srank": 16
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sambit Kumar Mahanta",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196807306",
    "school": "Mount Litra Zee School",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Samikshya Dalai",
    "orank": 15,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196807307",
    "school": "DAV Public school",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Samikshya Nanda",
    "orank": 62,
    "prize": "",
    "roll": "AR196807308",
    "school": "Mount Litra Zee School",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sandeep Kumar Mahanta",
    "orank": 121,
    "prize": "",
    "roll": "AR196807309",
    "school": "Cohen International",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sanskruti Mohanty Mohapatra",
    "orank": 245,
    "prize": "",
    "roll": "AR196804602",
    "school": "Kendriya Vidyalaya No 1, Bhubaneshwar",
    "score": "25 / 50",
    "srank": 20
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Shriyans Kar",
    "orank": 9,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196807310",
    "school": "Mount Litra Zee School",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Shubham Swarup Das",
    "orank": 62,
    "prize": "",
    "roll": "AR196807311",
    "school": "Mount Litra Zee School",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Smarak Sekhar Rout",
    "orank": 15,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196807312",
    "school": "Mount Litra Zee School",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sruti Saurabh Mohanty",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "AR196807313",
    "school": "Mount Litra Zee School",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sumedha shree Sahu",
    "orank": 99,
    "prize": "",
    "roll": "AR196807314",
    "school": "Mount Litra Zee School",
    "score": "42/50",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Suvam Preet Satapathy",
    "orank": 79,
    "prize": "",
    "roll": "AR196807315",
    "school": "Mount Litra Zee School",
    "score": "43/50",
    "srank": 8
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Swaha Swastika Nayak",
    "orank": 55,
    "prize": "",
    "roll": "AR196807316",
    "school": "Mount Litra Zee School",
    "score": "45/50",
    "srank": 6
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Swastik Mohanty",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196807317",
    "school": "DAV Public School Chandrasekharpur",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Swastik Mohanty",
    "orank": 201,
    "prize": "",
    "roll": "AR196804605",
    "school": "DAV Public School Chandrasekharpur",
    "score": "28 / 50",
    "srank": 16
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Tanush Mishra",
    "orank": 9,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196807318",
    "school": "DAV Public School Chandrasekharpur",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Upasana Patra",
    "orank": 136,
    "prize": "",
    "roll": "AR196807319",
    "school": "Mount Litra Zee School",
    "score": "40/50",
    "srank": 12
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ved Amol Dangore",
    "orank": 9,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196807320",
    "school": "Mount Litra Zee School",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "7",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Viraat Prabir Pradhan",
    "orank": 148,
    "prize": "",
    "roll": "AR196807321",
    "school": "Mount Litra Zee School",
    "score": "39/50",
    "srank": 13
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aaeshanee mishra",
    "orank": 135,
    "prize": "",
    "roll": "AS196807613",
    "school": "Kendriya Vidyalaya number 1 Bhubaneswar",
    "score": "31 / 40",
    "srank": 14
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "ADITYA NARAYAN SAHU",
    "orank": 135,
    "prize": "",
    "roll": "AS196807618",
    "school": "DAV PUBLIC SCHOOL CANDRASEKHARPUR BHUBANESWAR",
    "score": "31 / 40",
    "srank": 14
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Akshyat Aadit Sahu",
    "orank": 235,
    "prize": "",
    "roll": "AS196804607",
    "school": "DAV Public School Cspur",
    "score": "22 / 50",
    "srank": 20
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Amrita Pani",
    "orank": 125,
    "prize": "",
    "roll": "AS196807612",
    "school": "KV No.1 BBSR , 2nd Shift",
    "score": "37 / 40",
    "srank": 11
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aratrika Bhuyan",
    "orank": 269,
    "prize": "",
    "roll": "AS196807450",
    "school": "Lumbini Public School",
    "score": "20 / 50",
    "srank": 22
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "ASMIN KUMAR SAHOO",
    "orank": 301,
    "prize": "",
    "roll": "AS196804603",
    "school": "KENDRIYA VIDYALAYA NO. 1 BHUBANESWAR",
    "score": "15 / 50",
    "srank": 24
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Bedavyash Jena ",
    "orank": "",
    "prize": "",
    "roll": "AS196804608",
    "school": "KENDRIYA VIDYALAYA NO-1",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Bhagyalaxmi Sahoo",
    "orank": 2,
    "prize": "Cash award of Rs.1500/- (Prize shared) Olympiad Silver Medal ",
    "roll": "AS196807233",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Bhumika",
    "orank": 209,
    "prize": "",
    "roll": "AS196804605",
    "school": "DAV PUBLIC SCHOOL CHANDRASEKHARPUR",
    "score": "25 / 50",
    "srank": 19
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Dibyansa Mohanty",
    "orank": 145,
    "prize": "",
    "roll": "AS196804448",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "29 / 50",
    "srank": 15
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Jigyansa Mohanty",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196807447",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Mayank Kumar Singh",
    "orank": 235,
    "prize": "",
    "roll": "AS196804454",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "22 / 50",
    "srank": 20
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Namya Swain",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196804449",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Priyabrata Behera",
    "orank": 169,
    "prize": "",
    "roll": "AS196804446",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "27 / 50",
    "srank": 17
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rajkanya Swain",
    "orank": 289,
    "prize": "",
    "roll": "AS196804452",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "19 / 50",
    "srank": 23
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ritisha Mohapatra",
    "orank": 235,
    "prize": "",
    "roll": "AS196804609",
    "school": "DAV CSPUR BBSR",
    "score": "22 / 50",
    "srank": 20
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Roshni Ruhansika Panda",
    "orank": 189,
    "prize": "",
    "roll": "AS196804455",
    "school": "Lumbini Public School",
    "score": "26 / 50",
    "srank": 18
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Saanvi Parida",
    "orank": 135,
    "prize": "",
    "roll": "AS196807615",
    "school": "Kendriya Vidyalaya No. 1",
    "score": "31 / 40",
    "srank": 14
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Saisampurna Behera",
    "orank": 159,
    "prize": "",
    "roll": "AS196804453",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "28 / 50",
    "srank": 16
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Samikshya Dalai",
    "orank": 245,
    "prize": "",
    "roll": "AS196804610",
    "school": "DAV Public school",
    "score": "21 / 50",
    "srank": 21
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sanskruti Mohanty Mohapatra",
    "orank": 209,
    "prize": "",
    "roll": "AS196804604",
    "school": "Kendriya Vidyalaya No.1, BBSR",
    "score": "25 / 50",
    "srank": 19
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sattvik Sarangi",
    "orank": "",
    "prize": "",
    "roll": "AS196804611",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "7",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Subhra",
    "orank": 209,
    "prize": "",
    "roll": "AS196807444",
    "school": "Lumbini Public School",
    "score": "25 / 50",
    "srank": 19
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Animes Panigrahi",
    "orank": 101,
    "prize": "",
    "roll": "AS196807544",
    "school": "DAV CHANDRASEKHARPUR",
    "score": "42/50",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Anish Satapathy",
    "orank": 2,
    "prize": "Cash award of Rs.1500/- (Prize shared) Olympiad Silver Medal ",
    "roll": "AS196807545",
    "school": "dav chandrasekharpur",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Anuj Kumar Soni",
    "orank": 23,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196807547",
    "school": "Cohen International",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Anurag Mohanty",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "AS196807548",
    "school": "Cohen International",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Anuska Ankshita Samal",
    "orank": 51,
    "prize": "",
    "roll": "AS196807549",
    "school": "Cohen International",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Anwesha Praharaj",
    "orank": 101,
    "prize": "",
    "roll": "AS196807550",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "42/50",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Aradhya Anuradha Mohapatra",
    "orank": 23,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196807551",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Armaan Jena",
    "orank": 51,
    "prize": "",
    "roll": "AS196807552",
    "school": "St. Xaviers Dist. Centre",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Arnab Kumar Bisoi",
    "orank": 59,
    "prize": "",
    "roll": "AS196807553",
    "school": "St. Xaviers Dist. Centre",
    "score": "45/50",
    "srank": 6
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Aryan Das",
    "orank": 81,
    "prize": "",
    "roll": "AS196807554",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "43/50",
    "srank": 8
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Aspruha Sahu",
    "orank": 68,
    "prize": "",
    "roll": "AS196807555",
    "school": "Krishnamurthy world school",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Avni Nayak",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196807556",
    "school": "Bal Bharati Public School",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Ayushman Dattatreya Das",
    "orank": 23,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196807557",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Bahumanya Prusty",
    "orank": 120,
    "prize": "",
    "roll": "AS196807265",
    "school": "DAV Public School, CSPur",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Bhagyalaxmi Sahoo",
    "orank": 131,
    "prize": "",
    "roll": "SS196807100",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "39 / 40",
    "srank": 4
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Chiranyachoudhury",
    "orank": 101,
    "prize": "School Silver Medal",
    "roll": "Ss196804122",
    "school": "Dav cspur, bbsr",
    "score": "43 / 50",
    "srank": 2
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Dibyansa Mohanty",
    "orank": 165,
    "prize": "",
    "roll": "SS196804224",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 7
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Jigyansa Mohanty",
    "orank": 189,
    "prize": "",
    "roll": "SS196804223",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "20 / 50",
    "srank": 8
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Labdhi Swain",
    "orank": 149,
    "prize": "",
    "roll": "SS196804117",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "28 / 50",
    "srank": 5
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Priyabrata Behera",
    "orank": 156,
    "prize": "",
    "roll": "SS196804222",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "27 / 50",
    "srank": 6
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "R. Rithwik",
    "orank": 123,
    "prize": "School Bronze Medal",
    "roll": "SS196807127",
    "school": "DAV public school",
    "score": "41/50",
    "srank": 3
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Saieesha Mishra",
    "orank": 99,
    "prize": "",
    "roll": "SS196804118",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "45 / 50",
    "srank": 6
  },
  {
    "class": "7",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Sanskruti Mohanty Mohapatra",
    "orank": 149,
    "prize": "",
    "roll": "SS196804120",
    "school": "Kendriya Vidyalaya no 1, 2nd Shift, BBSR",
    "score": "28 / 50",
    "srank": 5
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "ADITI ADYASHA MOHAPATRA",
    "orank": 132,
    "prize": "",
    "roll": "AT196807722",
    "school": "KENDRIYA VIDYALAYA NO.-01, UNIT -IX, BHOI NAGAR, BHUBANESWAR",
    "score": "26 / 40",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Aratrika Bhuyan",
    "orank": 43,
    "prize": "Special Prize",
    "roll": "AT196804461",
    "school": "Lumbini Public School",
    "score": "40 / 50",
    "srank": 5
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Asmin Kumar Sahoo",
    "orank": 14,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AT196804812",
    "school": "Kendriya vidyalaya NO-1Bhubaneswer",
    "score": "46 / 50",
    "srank": 3
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Bhagyalaxmi Sahoo",
    "orank": 61,
    "prize": "",
    "roll": "AT196807635",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "39 / 50",
    "srank": 6
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Dibyansa Mohanty",
    "orank": 8,
    "prize": "School Silver Medal + Special prize",
    "roll": "AT196804459",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "49 / 50",
    "srank": 2
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Goutami Saishradha Biswal",
    "orank": 132,
    "prize": "",
    "roll": "AT196804814",
    "school": "DAV Public School, Chandrasekharpur, Bhubaneswar-21",
    "score": "26 / 50",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Jigyansa Mohanty",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "AT196804458",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "41 / 50",
    "srank": 4
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Namya Swain",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AT196804460",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Rajkanya Swain",
    "orank": 61,
    "prize": "",
    "roll": "AT196804463",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "39 / 50",
    "srank": 6
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Saieesha Mishra",
    "orank": 89,
    "prize": "",
    "roll": "AT196804811",
    "school": "Kendriya vidyalaya no.1",
    "score": "34 / 50",
    "srank": 7
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Saisampurna Behera",
    "orank": 100,
    "prize": "",
    "roll": "AT196804464",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "28 / 50",
    "srank": 8
  },
  {
    "class": "7",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Sanskruti Mohanty Mohapatra",
    "orank": 132,
    "prize": "",
    "roll": "AT196804813",
    "school": "Kendriya Vidyalaya no 1, Bhubaneswar",
    "score": "26 / 50",
    "srank": 9
  },
  {
    "class": "7",
    "exam": "",
    "name": "Bahumanya Prusty",
    "orank": 8,
    "prize": "School Silver Medal + Special prize",
    "roll": "AT196807166",
    "school": "DAV Public School, CSPur",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aahana Mohapatra",
    "orank": 41,
    "prize": "Special Prize",
    "roll": "AM196808420",
    "school": "Sai International school",
    "score": "44/50",
    "srank": 7
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Advika Das",
    "orank": 194,
    "prize": "",
    "roll": "AM196808611",
    "school": "Kendriya vidyalaya no.1",
    "score": "26 / 50",
    "srank": 17
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anand Yadav",
    "orank": 101,
    "prize": "",
    "roll": "AM196808113",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "38 / 50",
    "srank": 13
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ankit Solanki",
    "orank": 89,
    "prize": "",
    "roll": "AM196808112",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "39 / 50",
    "srank": 12
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aryaveer Raj Biswal",
    "orank": "",
    "prize": "",
    "roll": "AM196805512",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ashirbad Das",
    "orank": 256,
    "prize": "",
    "roll": "AM196805511",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "22 / 50",
    "srank": 20
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ashirbad Nayak",
    "orank": 56,
    "prize": "",
    "roll": "AM196809427",
    "school": "Dav Public School Chandrasekharpur",
    "score": "41 / 50",
    "srank": 10
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ashutosh Behera",
    "orank": 321,
    "prize": "",
    "roll": "AM196805499",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "19 / 50",
    "srank": 22
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bibaswan Panda",
    "orank": 39,
    "prize": "Special Prize",
    "roll": "AM196808235",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "45/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bidisha Pati",
    "orank": 71,
    "prize": "",
    "roll": "AM196808425",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "40/50",
    "srank": 11
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bidisha Saanvi",
    "orank": 89,
    "prize": "",
    "roll": "AM196808426",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "39/50",
    "srank": 12
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bidyanshi Biswarupa",
    "orank": 159,
    "prize": "",
    "roll": "AM196808427",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "31/50",
    "srank": 15
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Biswo Ranjan Pradhan",
    "orank": 297,
    "prize": "",
    "roll": "AM196805222",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "20 / 50",
    "srank": 21
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Chirantan Satapathy",
    "orank": 31,
    "prize": "Special Prize",
    "roll": "AM196808428",
    "school": "Dav cspur, bbsr",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Debanshee Sarangi",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196808429",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Devansh Senapati",
    "orank": 21,
    "prize": "Special Prize",
    "roll": "AM196808430",
    "school": "St.Xavier High School, Satyanagar",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dibyajyoti S. Sethy",
    "orank": 15,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196808431",
    "school": "DAV public School Chandrasekharpur",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Dikshita Priyadarshini",
    "orank": 9,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196808432",
    "school": "Kendriya Vidyalaya no-1 2nd shift bhubaneswar",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Durgasish Panda ",
    "orank": 71,
    "prize": "",
    "roll": "AM196808433",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "40/50",
    "srank": 11
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Gitik Sreyansh Baral",
    "orank": 31,
    "prize": "Special Prize",
    "roll": "AM196808434",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ishan Dhal ",
    "orank": 15,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196808435",
    "school": "Cohen International",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ishika Senapati",
    "orank": 71,
    "prize": "",
    "roll": "AM196808436",
    "school": "Cohen International",
    "score": "40/50",
    "srank": 11
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ishita Priyadarshini",
    "orank": 56,
    "prize": "",
    "roll": "AM196808437",
    "school": "Cohen International",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jagruti Jena",
    "orank": 89,
    "prize": "",
    "roll": "AM196808438",
    "school": "Cohen International",
    "score": "39/50",
    "srank": 12
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jaikrish Das",
    "orank": 175,
    "prize": "",
    "roll": "AM196805231",
    "school": "Lumbini Public School",
    "score": "29 / 50",
    "srank": 16
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Jyotiprakash Behera",
    "orank": 201,
    "prize": "",
    "roll": "AM196805505",
    "school": "Kendriya Vidyalaya no. 4",
    "score": "25 / 50",
    "srank": 18
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "jyotishman Mohanty",
    "orank": 31,
    "prize": "Special Prize",
    "roll": "AM196808439",
    "school": "Kendriya Vidyalaya no. 4",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Koustuv Sahoo",
    "orank": 123,
    "prize": "",
    "roll": "AM196808440",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "37/50",
    "srank": 14
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Lagna nayak",
    "orank": "",
    "prize": "",
    "roll": "AM196808614",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Mahalasha Roul",
    "orank": 9,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196808441",
    "school": "Loyola School",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Manyabta Mohanty",
    "orank": 48,
    "prize": "Special Prize",
    "roll": "AM196808442",
    "school": "Lumbini Public School",
    "score": "43/50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Moksh Agarwal",
    "orank": 51,
    "prize": "",
    "roll": "AM196808443",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "42/50",
    "srank": 9
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Mrinali Nanda",
    "orank": 89,
    "prize": "",
    "roll": "AM196808444",
    "school": "DAV Public School, Garage Chhak",
    "score": "39/50",
    "srank": 12
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "NAIVEDYA BARAL",
    "orank": 21,
    "prize": "Special Prize",
    "roll": "AM196805503",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Navya Namasya Kar",
    "orank": 123,
    "prize": "",
    "roll": "AM196808445",
    "school": "DAV Public School, Garage Chhak",
    "score": "37/50",
    "srank": 14
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Nirlipta Priyadarshini Behera",
    "orank": 15,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196808446",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Nirvan Pattanayak",
    "orank": 201,
    "prize": "",
    "roll": "AM196810112",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 18
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Om Saha",
    "orank": 21,
    "prize": "Special Prize",
    "roll": "AM196808447",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rajveer Parida",
    "orank": 201,
    "prize": "",
    "roll": "AM196805224",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 18
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "RITWIK RONAK PRADHAN",
    "orank": "",
    "prize": "",
    "roll": "AM196805509",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai Priyanshu Rout",
    "orank": 297,
    "prize": "",
    "roll": "AM196805226",
    "school": "Lumbini Public School",
    "score": "20 / 50",
    "srank": 21
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai Shankalp Mohanty",
    "orank": 194,
    "prize": "",
    "roll": "AM196805223",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "26 / 50",
    "srank": 17
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai Shibam Jena",
    "orank": 389,
    "prize": "",
    "roll": "AM196805502",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "15 / 50",
    "srank": 25
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Saiprasad Nayak",
    "orank": 39,
    "prize": "Special Prize",
    "roll": "AM196805506",
    "school": "Kendriya vidyalaya 4",
    "score": "45/50",
    "srank": 27
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shaanvi Mohapatra ",
    "orank": "",
    "prize": "",
    "roll": "AR196805511",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shivanshi Sahu",
    "orank": 223,
    "prize": "",
    "roll": "AM196805504",
    "school": "DAV Public School CSpur",
    "score": "24 / 50",
    "srank": 19
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Silky samanwoya Rout",
    "orank": 223,
    "prize": "",
    "roll": "AM196805500",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "24 / 50",
    "srank": 19
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Somya Sohen Singh",
    "orank": 345,
    "prize": "",
    "roll": "AM196805501",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "18 / 50",
    "srank": 23
  },
  {
    "class": "8",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Tanushree Behera",
    "orank": 201,
    "prize": "",
    "roll": "AM196805227",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 18
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Anand Yadav",
    "orank": 111,
    "prize": "",
    "roll": "AR196808627",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "38 / 50",
    "srank": 9
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ankit Solanki",
    "orank": 94,
    "prize": "",
    "roll": "AR196808626",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "39 / 50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ashutosh Behera",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196805918",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "50 / 50",
    "srank": 1
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Jaikrish Das",
    "orank": 71,
    "prize": "",
    "roll": "AR196805576",
    "school": "Lumbini Public School",
    "score": "41/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Jyotiprakash Behera",
    "orank": 79,
    "prize": "",
    "roll": "AR196805920",
    "school": "Kendriya Vidyalaya no.4",
    "score": "40/50",
    "srank": 7
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Mohit Mohan Pradhan",
    "orank": 21,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196805921",
    "school": "DAV Public school chandrasekharpur BBSR Odisha",
    "score": "47/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "NAIVEDYA BARAL",
    "orank": 36,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196805919",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "45/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Omm Swaroop Rout",
    "orank": 135,
    "prize": "",
    "roll": "AR196808874",
    "school": "DAV PUBLIC SCHOOL CS PUR",
    "score": "33 / 50",
    "srank": 11
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Rajveer Parida",
    "orank": 94,
    "prize": "",
    "roll": "AR196805569",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "39/50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sai Jeev Devaansh Jena",
    "orank": 21,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196805924",
    "school": "Kendriya vidyalaya No-1, Bhubaneswar",
    "score": "47/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sai Priyanshu Rout",
    "orank": 56,
    "prize": "",
    "roll": "AR196805571",
    "school": "Lumbini Public School",
    "score": "44/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Saiprasad Nayak",
    "orank": 94,
    "prize": "",
    "roll": "AR196805922",
    "school": "Kendriya vidyalaya 4",
    "score": "39/50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Tanushree Behera",
    "orank": 64,
    "prize": "",
    "roll": "AR196805572",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "42/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aastha Ankita",
    "orank": 3,
    "prize": "Cash award of Rs.1000/- (Prize shared) Olympiad Bronze Medal ",
    "roll": "AS196808547",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Adhrit Satapathy",
    "orank": 89,
    "prize": "",
    "roll": "AS196808548",
    "school": "Cohen International",
    "score": "44/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Adrika Sar",
    "orank": 135,
    "prize": "",
    "roll": "AS196808549",
    "school": "Kendriya vidyalaya no 1",
    "score": "42/50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Advika Das",
    "orank": 89,
    "prize": "",
    "roll": "AS196808520",
    "school": "Kendriya Vidyalaya no.1",
    "score": "44/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Adweta Mishra",
    "orank": 56,
    "prize": "",
    "roll": "AS196808550",
    "school": "D.A.V PUBLIC SCHOOL UNIT- 8 BBSR",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Adyasha Mohapatra",
    "orank": 19,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196808551",
    "school": "DAV public school",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ahana Swain ",
    "orank": 135,
    "prize": "",
    "roll": "AS196808552",
    "school": "Kendriya Vidyalaya no 1 BBSR",
    "score": "42/50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Akankshya Routray",
    "orank": 37,
    "prize": "Special Prize",
    "roll": "AS196808553",
    "school": "DAV Public School Cspur",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Akhyansh Ashneet",
    "orank": 89,
    "prize": "",
    "roll": "AS196808554",
    "school": "DAV Public School Cspur",
    "score": "44/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Akshita Mohapatra",
    "orank": 19,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196808555",
    "school": "DAV Public School Cspur",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Amlan Kiran Dalai",
    "orank": 56,
    "prize": "",
    "roll": "AS196808556",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Anand Yadav",
    "orank": 19,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196808113",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ananya Patra",
    "orank": 37,
    "prize": "Special Prize",
    "roll": "AS196808557",
    "school": "Lumbini Public school",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Animesh Mahasuar",
    "orank": 159,
    "prize": "",
    "roll": "AS196808558",
    "school": "DAV CHANDRASEKHARPUR",
    "score": "41/50",
    "srank": 9
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ankit Solanki",
    "orank": 19,
    "prize": "Cash award of Rs.1000/- (Prize shared) Olympiad Bronze Medal ",
    "roll": "AS196808112",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aryaveer Raj Biswal",
    "orank": "",
    "prize": "",
    "roll": "AS196805747",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ashirbad Das",
    "orank": 287,
    "prize": "",
    "roll": "AS196805748",
    "school": "Dav public school cspur",
    "score": "25 / 50",
    "srank": 16
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ashirbad Nayak",
    "orank": 123,
    "prize": "",
    "roll": "AS196809350",
    "school": "DAV PUBLIC SCHOOL,CHANDRASEKHARPUR,BBSR",
    "score": "43 / 50",
    "srank": 7
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ashutosh behera",
    "orank": 345,
    "prize": "",
    "roll": "AS196805740",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "20 / 50",
    "srank": 19
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Bibaswan Panda",
    "orank": 159,
    "prize": "",
    "roll": "AS196808154",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "41/50",
    "srank": 10
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Biswo Ranjan Pradhan",
    "orank": 345,
    "prize": "",
    "roll": "AS196805550",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "20 / 50",
    "srank": 19
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Dibyansha Sahoo",
    "orank": 267,
    "prize": "",
    "roll": "AS196805749",
    "school": "DAV public School Chandrasekharpur",
    "score": "26 / 50",
    "srank": 15
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Diptanshu Behera",
    "orank": 56,
    "prize": "",
    "roll": "AS196806558",
    "school": "DAV Public School Chandrasekharpur Bhubaneswar",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Jaikrish Das",
    "orank": 234,
    "prize": "",
    "roll": "AS196805559",
    "school": "Lumbini Public School",
    "score": "29 / 50",
    "srank": 13
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Naivedya baral",
    "orank": 345,
    "prize": "",
    "roll": "AS196805743",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "20 / 50",
    "srank": 19
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nirvan Pattanayak",
    "orank": 287,
    "prize": "",
    "roll": "AS196810228",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 16
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Pratyush Lenka",
    "orank": 198,
    "prize": "",
    "roll": "AS196808454",
    "school": "Cohen International",
    "score": "39/50",
    "srank": 11
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Prayas Mohapatra",
    "orank": 159,
    "prize": "",
    "roll": "AS196808455",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "41/50",
    "srank": 9
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rajveer Parida",
    "orank": 287,
    "prize": "",
    "roll": "AS196808552",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 16
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Reeshbh Rout",
    "orank": 89,
    "prize": "",
    "roll": "AS196808456",
    "school": "Mount Litra Zee School",
    "score": "44/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Reyansh Mohapatra",
    "orank": 3,
    "prize": "Cash award of Rs.1000/- (Prize shared) Olympiad Bronze Medal ",
    "roll": "AS196808457",
    "school": "Mount Litra Zee School",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rishabh Sahoo",
    "orank": 174,
    "prize": "",
    "roll": "AS196808458",
    "school": "Mount Litra Zee School",
    "score": "40/50",
    "srank": 10
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai Priyanshu Rout",
    "orank": 345,
    "prize": "",
    "roll": "AS196805554",
    "school": "Lumbini Public School",
    "score": "20 / 50",
    "srank": 19
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai Shankalp Mohanty",
    "orank": 267,
    "prize": "",
    "roll": "AS196805551",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "26 / 50",
    "srank": 15
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai Shibam Jena",
    "orank": 301,
    "prize": "",
    "roll": "AS196805742",
    "school": "Kendriya Vidiyalaya No -1,unit - 9, BBSR (Second shift)",
    "score": "23 / 50",
    "srank": 17
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Saiprasad Nayak",
    "orank": 301,
    "prize": "",
    "roll": "AS196805746",
    "school": "Kendriya vidyalaya 4",
    "score": "23 / 50",
    "srank": 17
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Saishruti Dash",
    "orank": 198,
    "prize": "",
    "roll": "AS196808459",
    "school": "Mount Litra Zee School",
    "score": "39/50",
    "srank": 11
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Saiswarup Tarasia",
    "orank": 159,
    "prize": "",
    "roll": "AS196808460",
    "school": "Mount Litra Zee School",
    "score": "41/50",
    "srank": 9
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Samadarshi Sarvajit Behera",
    "orank": 213,
    "prize": "",
    "roll": "AS196808461",
    "school": "Mount Litra Zee School",
    "score": "38/50",
    "srank": 12
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shaanvi Mohapatra ",
    "orank": "",
    "prize": "",
    "roll": "AS196805750",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shivanshi Sahu",
    "orank": 245,
    "prize": "",
    "roll": "AS196805744",
    "school": "DAV Public School CSpur",
    "score": "27 / 50",
    "srank": 14
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shreyansh Beura",
    "orank": 89,
    "prize": "",
    "roll": "AS196808462",
    "school": "Kendriya vidyalaya no 7",
    "score": "44/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shreyansh Nanda",
    "orank": 56,
    "prize": "",
    "roll": "AS196808463",
    "school": "Kendriya vidyalaya no 11",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shreyansh Nayak",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196808464",
    "school": "Kendriya vidyalaya no 12",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shriya Mondal",
    "orank": 37,
    "prize": "Special Prize",
    "roll": "AS196808465",
    "school": "Mount Litra Zee School",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Silky samanwoya Rout",
    "orank": 367,
    "prize": "",
    "roll": "AS196805741",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "17 / 50",
    "srank": 20
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sobhan Saiskrit Moharana",
    "orank": 56,
    "prize": "",
    "roll": "AS196808466",
    "school": "Mount Litra Zee School",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sohan Sudeep Hansda",
    "orank": 135,
    "prize": "",
    "roll": "AS196808467",
    "school": "Mount Litra Zee School",
    "score": "42/50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Subrachi pati",
    "orank": 321,
    "prize": "",
    "roll": "AS196805745",
    "school": "Kendriya vidyalaya no 1 bhubaneswar",
    "score": "22 / 50",
    "srank": 18
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sugyani Shree Nayak",
    "orank": 159,
    "prize": "",
    "roll": "AS196808468",
    "school": "Mount Litra Zee School",
    "score": "41/50",
    "srank": 9
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Tanushree Behera",
    "orank": 287,
    "prize": "",
    "roll": "AS196805555",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "25 / 50",
    "srank": 16
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Tapendu Kumar Mohakud",
    "orank": 198,
    "prize": "",
    "roll": "AS196808469",
    "school": "Mount Litra Zee School",
    "score": "39/50",
    "srank": 11
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Tejas Das",
    "orank": 174,
    "prize": "",
    "roll": "AS196808470",
    "school": "Mount Litra Zee School",
    "score": "40/50",
    "srank": 10
  },
  {
    "class": "8",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Vidya Vinita Mishra",
    "orank": 37,
    "prize": "Special Prize",
    "roll": "AS196808471",
    "school": "Mount Litra Zee School",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Aadya Das",
    "orank": 31,
    "prize": "Special Prize",
    "roll": "SS196808090",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "44/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Anand Yadav",
    "orank": 35,
    "prize": "Special Prize",
    "roll": "SS196808089",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "43/50",
    "srank": 7
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Ankit Solanki",
    "orank": 49,
    "prize": "Special Prize",
    "roll": "SS196808088",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "41/50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Aryanshu Tripathy",
    "orank": 12,
    "prize": "School Bronze Medal + Special prize",
    "roll": "SS196808254",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "48/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Asutosh Sasmal",
    "orank": 23,
    "prize": "Special Prize",
    "roll": "SS196808255",
    "school": "Krishnamurthy world school",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Avni Nayak",
    "orank": 8,
    "prize": "School Silver Medal + Special prize",
    "roll": "SS196808256",
    "school": "Bal Bharati Public School",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Ayushman Dibyasingh Behera",
    "orank": 99,
    "prize": "",
    "roll": "SS196808257",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "36/50",
    "srank": 11
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Bhavani Sankar Das",
    "orank": 31,
    "prize": "Special Prize",
    "roll": "SS196808258",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "44/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Biswo Ranjan Pradhan",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared), Olympiad Gold Medal ",
    "roll": "SS196805208",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Manjit nayak",
    "orank": 66,
    "prize": "",
    "roll": "SS196805154",
    "school": "Kendriya vidyalaya no 4 bbsr",
    "score": "39/50",
    "srank": 9
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Rajveer Parida",
    "orank": 8,
    "prize": "School Silver Medal + Special prize",
    "roll": "SS196805210",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Sai Shankalp Mohanty",
    "orank": 15,
    "prize": "Special Prize",
    "roll": "SS196805209",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "47/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Saiprasad Nayak",
    "orank": 86,
    "prize": "",
    "roll": "SS196805155",
    "school": "Kendriya vidyalaya 4, Niladrivihar",
    "score": "37/50",
    "srank": 10
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Anand Yadav",
    "orank": 56,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196808113",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "46/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Ankit Solanki",
    "orank": 3,
    "prize": "Cash award of Rs.1000/- (Prize shared) Olympiad Bronze Medal ",
    "roll": "AS196808112",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Anupam Rath",
    "orank": 21,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AT196808358",
    "school": "Cohen International",
    "score": "47/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Anuprash Swain",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "AT196808359",
    "school": "Cohen International",
    "score": "46/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Anvesh Subham Pradhan ",
    "orank": 13,
    "prize": "School Silver Medal + Special prize",
    "roll": "AT196808360",
    "school": "Cohen International",
    "score": "49/50",
    "srank": 2
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Anwesha Priyadarshini",
    "orank": 93,
    "prize": "",
    "roll": "AT196808361",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "40/50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Aradhya Priyanka Das",
    "orank": 75,
    "prize": "",
    "roll": "AT196808362",
    "school": "Lumbini Public School",
    "score": "41/50",
    "srank": 6
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Arman Nayak",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "AT196808363",
    "school": "St. Xaviers Dist. Centre",
    "score": "46/50",
    "srank": 4
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Arnav Dash",
    "orank": 21,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AT196808364",
    "school": "St. Xaviers Dist. Centre",
    "score": "47/50",
    "srank": 3
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Aryan Das",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AT196808365",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "50/50",
    "srank": 1
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Bibaswan Panda",
    "orank": 93,
    "prize": "",
    "roll": "AT196808321",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "40/50",
    "srank": 8
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Biswo Ranjan Pradhan",
    "orank": 157,
    "prize": "",
    "roll": "AT196805258",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "38/50",
    "srank": 12
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Mohit mohan pradhan",
    "orank": 146,
    "prize": "",
    "roll": "AT196805721",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "34/50",
    "srank": 11
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Rajveer Parida",
    "orank": 54,
    "prize": "",
    "roll": "AT196805260",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "42/50",
    "srank": 5
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Sai Priyanshu Rout",
    "orank": 89,
    "prize": "",
    "roll": "AT196805262",
    "school": "Lumbini Public School",
    "score": "41/50",
    "srank": 7
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Sai Shankalp Mohanty",
    "orank": 135,
    "prize": "",
    "roll": "AT196805259",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "35/50",
    "srank": 10
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Saiprasad Nayak",
    "orank": 121,
    "prize": "",
    "roll": "AT196805722",
    "school": "Kendriya vidyalaya 4",
    "score": "37/50",
    "srank": 9
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "SRISHTI BASUMALLIK",
    "orank": "",
    "prize": "",
    "roll": "AT196805720",
    "school": "",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "8",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Tanushree Behera",
    "orank": 121,
    "prize": "",
    "roll": "AT196805263",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "37/50",
    "srank": 9
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aahana Pattanaik",
    "orank": 68,
    "prize": "",
    "roll": "AM196809320",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "53/60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aaradhya Choudhury",
    "orank": 39,
    "prize": "Special Prize",
    "roll": "AM196809234",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "55/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aarav Mohanty",
    "orank": 125,
    "prize": "",
    "roll": "AM196809235",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "49/60",
    "srank": 11
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aayan Mishra",
    "orank": 55,
    "prize": "",
    "roll": "AM196809236",
    "school": "K.V.S NO.1 BBSR UNIT-IX",
    "score": "54/60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adhrit",
    "orank": 138,
    "prize": "",
    "roll": "AM196809237",
    "school": "Cohen International",
    "score": "48/60",
    "srank": 12
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adrika Das",
    "orank": 17,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196809238",
    "school": "Kendriya vidyalaya no 1",
    "score": "57/60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Advaita Bisoyi",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196809239",
    "school": "Kendriya vidyalaya no 1",
    "score": "59/60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Adyasha Panda",
    "orank": 89,
    "prize": "",
    "roll": "AM196809240",
    "school": "DAV public school",
    "score": "51/60",
    "srank": 8
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aishani Mahapatra",
    "orank": 55,
    "prize": "",
    "roll": "AM196809241",
    "school": "Kendriya Vidyalaya no 1 BBSR",
    "score": "54/60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Akshita Panda",
    "orank": 25,
    "prize": "Special Prize",
    "roll": "AM196809242",
    "school": "DAV Public School Cspur",
    "score": "56/60",
    "srank": 4
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Amritanshu Sahoo",
    "orank": 39,
    "prize": "Special Prize",
    "roll": "AM196809243",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "55/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Animesh Padhihari ",
    "orank": 8,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196809244",
    "school": "DAV CHANDRASEKHARPUR",
    "score": "58/60",
    "srank": 2
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ankit Behera",
    "orank": 17,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196809245",
    "school": "dav chandrasekharpur",
    "score": "57/60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesh Mohapatra ",
    "orank": "",
    "prize": "",
    "roll": "AM196809426",
    "school": "Cohen International",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesha Patel",
    "orank": "",
    "prize": "",
    "roll": "AM196809428",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwesha Sahoo",
    "orank": 164,
    "prize": "",
    "roll": "AM196809246",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "45/60",
    "srank": 14
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Anwita Biswal",
    "orank": 189,
    "prize": "",
    "roll": "AM196809247",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "44/60",
    "srank": 15
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "APRAJITA",
    "orank": 39,
    "prize": "Special Prize",
    "roll": "AM196806551",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "55/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Archisman Patra",
    "orank": 201,
    "prize": "",
    "roll": "AM196809248",
    "school": "St. Xaviers Dist. Centre",
    "score": "39/60",
    "srank": 16
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Arnav Sanjeev Mishra",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196809249",
    "school": "Kendriya vidyalaya no 1 bhubaneshwar",
    "score": "59/60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aryan Padhy",
    "orank": 39,
    "prize": "Special Prize",
    "roll": "AM196809250",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "55/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Aryashree Mohapatra",
    "orank": 8,
    "prize": "School Silver Medal + Special Prize",
    "roll": "AM196809251",
    "school": "DAV PUBLIC SCHOOL CSPUR",
    "score": "58/60",
    "srank": 2
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Asutosh sasmal",
    "orank": 17,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AM196806547",
    "school": "Krishnamurthy world school",
    "score": "57 / 60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Atman Das",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AM196806543",
    "school": "kendriya Vidyalaya no.1",
    "score": "59 / 60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Bighnesh Mishra",
    "orank": 256,
    "prize": "",
    "roll": "AM196809425",
    "school": "DAV PUBLIC SCHOOL, UNIT 8",
    "score": "37 / 60",
    "srank": 18
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "chitranjali priyadarshini",
    "orank": 125,
    "prize": "",
    "roll": "AM196806549",
    "school": "kendraiya vidyalaya no 1 bhubaneswar",
    "score": "49 / 60",
    "srank": 11
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Lipsa Acharya",
    "orank": 256,
    "prize": "",
    "roll": "AM196806327",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "37 / 60",
    "srank": 18
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Md. Zisan",
    "orank": 201,
    "prize": "",
    "roll": "AM196806329",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "39 / 60",
    "srank": 16
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Ojas Samal",
    "orank": 157,
    "prize": "",
    "roll": "AM196806557",
    "school": "KV3 Bhubaneswar",
    "score": "46 / 60",
    "srank": 13
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Omm prakash sahoo",
    "orank": 164,
    "prize": "",
    "roll": "AM196806552",
    "school": "Kendriya vidyalaya No-1 BBSR",
    "score": "45 / 60",
    "srank": 14
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Rajdeep Jena",
    "orank": 201,
    "prize": "",
    "roll": "AM196806350",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "39 / 60",
    "srank": 16
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai prasad Behera",
    "orank": 224,
    "prize": "",
    "roll": "AM196806332",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "38 / 60",
    "srank": 17
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sai Sworup Parida",
    "orank": 164,
    "prize": "",
    "roll": "AM196806325",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "45 / 60",
    "srank": 14
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Sharanya Rout",
    "orank": 153,
    "prize": "School Gold Medal",
    "roll": "AM196809134",
    "school": "DAV Public School, CSPur",
    "score": "51/60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "Shreyanshi Sahu",
    "orank": 39,
    "prize": "Special Prize",
    "roll": "AM196806555",
    "school": "KV 1 Bhubaneswar Shift 1",
    "score": "55 / 60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "SUBHALAXMI SAHOO",
    "orank": 138,
    "prize": "",
    "roll": "AM196806546",
    "school": "ODISHA ADARSHA VIDYALAYA MASANIMUNDA KESINGA",
    "score": "48 / 60",
    "srank": 12
  },
  {
    "class": "9",
    "exam": "Asian Mathematics Olympiad (AMO) 2025-26",
    "name": "swayam sudip sahoo",
    "orank": 138,
    "prize": "",
    "roll": "AM196806542",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "48 / 60",
    "srank": 12
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "APRAJITA",
    "orank": "",
    "prize": "",
    "roll": "AR196806557",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Atmaja Punya Nanda",
    "orank": 56,
    "prize": "",
    "roll": "AR196809456",
    "school": "Krishnamurthy world school (kws)",
    "score": "45/60",
    "srank": 8
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ayaan Abideen",
    "orank": 5,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196809457",
    "school": "Bal Bharati Public School",
    "score": "58/60",
    "srank": 2
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ayushman Rath",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AR196809458",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "59/60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Barun Raj Biswal",
    "orank": 17,
    "prize": "Special Prize",
    "roll": "AR196809459",
    "school": "KENDRIYA VIDYALAYA NO-1",
    "score": "56/60",
    "srank": 4
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Bhavesh Panda",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AR196809460",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "48/60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Chiranya Choudhury",
    "orank": 28,
    "prize": "Special Prize",
    "roll": "AR196809461",
    "school": "Dav cspur, bbsr",
    "score": "55/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "chitranjali priyadarshini",
    "orank": 78,
    "prize": "",
    "roll": "AR196806556",
    "school": "kendriya vidyalaya no 1 bhubaneswar",
    "score": "42/60",
    "srank": 9
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Devansh Das",
    "orank": 13,
    "prize": "School Bronze Medal + Special Prize",
    "roll": "AR196809462",
    "school": "St.Xavier High School, Satyanagar",
    "score": "57/60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Md. Zisan",
    "orank": 35,
    "prize": "Special Prize",
    "roll": "AR196806900",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "49/60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Ojas Samal",
    "orank": 5,
    "prize": "School Silver Medal + Special prize",
    "roll": "AR196806560",
    "school": "Kv3 Bhubaneswar",
    "score": "58/60",
    "srank": 2
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Rajdeep Jena",
    "orank": 17,
    "prize": "Special Prize",
    "roll": "AR196806901",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "56/60",
    "srank": 4
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sai prasad Behera",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AR196806903",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "48/60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Reasoning & Aptitude  Olympiad (ARAO) 2025-26",
    "name": "Sai Sworup Parida",
    "orank": 28,
    "prize": "Special Prize",
    "roll": "AR196806896",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "55/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aadya Kar",
    "orank": 200,
    "prize": "",
    "roll": "AS196809543",
    "school": "St. Xavier high School, Satyanagar",
    "score": "41/60",
    "srank": 15
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aahana Mohapatra",
    "orank": 19,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196809544",
    "school": "Sai International school",
    "score": "58/60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Aahana Pattanaik",
    "orank": 58,
    "prize": "",
    "roll": "AS196809545",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "56/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Anwesha Patel",
    "orank": 179,
    "prize": "",
    "roll": "AS196809329",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "46 / 50",
    "srank": 12
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "APRAJITA",
    "orank": "",
    "prize": "",
    "roll": "AS196806563",
    "school": "K.V.NO.1, BHUBANESWAR,2ND SHIFT",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Asutosh sasmal",
    "orank": 58,
    "prize": "",
    "roll": "AS196806565",
    "school": "Krishnamurthy world school (kws)",
    "score": "56 / 60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Atman Das",
    "orank": 31,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196806555",
    "school": "Kendriya vidiyalaya No 1",
    "score": "58 / 60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Ayaana Singh",
    "orank": 226,
    "prize": "",
    "roll": "AS196806560",
    "school": "Bal Bharati Public School",
    "score": "39 / 60",
    "srank": 16
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "CHITRANJALI PRIYADARSHINI",
    "orank": 179,
    "prize": "",
    "roll": "AS196806562",
    "school": "KENDRIYA VIDYALAYA NO 1 BHUBANESWAR",
    "score": "46 / 60",
    "srank": 12
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Devanshi Debashrita",
    "orank": 188,
    "prize": "",
    "roll": "AS196809387",
    "school": "St.Xavier High School, Satyanagar",
    "score": "45/60",
    "srank": 13
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Dibyansh Das",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AS196809388",
    "school": "K.V. no- 1,(1st shift) BBSR",
    "score": "60/60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Eashan Nayak",
    "orank": 11,
    "prize": "School Silver Medal + Special prize",
    "roll": "AS196809390",
    "school": "Kendriya Vidyalaya no - 2",
    "score": "59/60",
    "srank": 2
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Jagruti Pattanaik",
    "orank": 31,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196809391",
    "school": "Cohen International",
    "score": "58/60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "K.Animesh",
    "orank": 158,
    "prize": "",
    "roll": "AS196809392",
    "school": "Kendriya Vidyalaya no. 4",
    "score": "49/60",
    "srank": 10
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Krishendu Panda",
    "orank": 58,
    "prize": "",
    "roll": "AS196809393",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "56/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "MAHROOF AHMED KHAN ",
    "orank": 113,
    "prize": "",
    "roll": "AS196809394",
    "school": "DAV Unit - 8",
    "score": "52/60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "MASROOR AHMED KHAN",
    "orank": 99,
    "prize": "",
    "roll": "AS196809395",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "55/60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Md. Zisan",
    "orank": 158,
    "prize": "",
    "roll": "AS196806339",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "49 / 60",
    "srank": 10
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Mokshita Das",
    "orank": 19,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AS196809396",
    "school": "DAV Public school chandrasekharpur BBSR Odisha",
    "score": "58/60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nikhil Kumar Das",
    "orank": 144,
    "prize": "",
    "roll": "AS196809397",
    "school": "DAV Public School, CSPUR, Bhubaneswar-23",
    "score": "50/60",
    "srank": 9
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nirvan Pattanayak",
    "orank": 58,
    "prize": "",
    "roll": "AS196809398",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "56/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Nishant Kumar ",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AS196809399",
    "school": "Kendriya Vidyalaya no - 4",
    "score": "57/60",
    "srank": 4
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "OJAS SAMAL",
    "orank": 125,
    "prize": "",
    "roll": "AS196806569",
    "school": "Kendriya Vidyalaya No.3 Bhubaneswar",
    "score": "51 / 60",
    "srank": 8
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Omm Prakash Bhuyan",
    "orank": 125,
    "prize": "",
    "roll": "AS196809400",
    "school": "Kendriya Vidyalaya NO.1 Bhubaneswar 1st shift",
    "score": "51/60",
    "srank": 8
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Pratyush Mishra",
    "orank": 199,
    "prize": "",
    "roll": "AS196809401",
    "school": "Cohen International",
    "score": "44/60",
    "srank": 14
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Rajdeep Jena",
    "orank": 11,
    "prize": "School Silver Medal + Special prize",
    "roll": "AS196806340",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "59 / 60",
    "srank": 2
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai prasad Behera",
    "orank": 162,
    "prize": "",
    "roll": "AS196806342",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "48 / 60",
    "srank": 11
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sai Sworup Parida",
    "orank": 99,
    "prize": "",
    "roll": "AS196806335",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "55 / 60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Satya sworup pratihari",
    "orank": 99,
    "prize": "",
    "roll": "AS196806564",
    "school": "K.v.no 1,1shift",
    "score": "55 / 60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Sharanya Rout",
    "orank": 125,
    "prize": "School Gold Medal",
    "roll": "AS196809287",
    "school": "DAV Public school chandrasekharpur BBSR Odisha",
    "score": "41/60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "Shreyanshi Sahu",
    "orank": 113,
    "prize": "",
    "roll": "As196806567",
    "school": "Kendriya Vidyalaya No-1 Bhubaneswar 1st Shift",
    "score": "52 / 60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "SUBHALAXMI SAHOO",
    "orank": 162,
    "prize": "",
    "roll": "AS196806559",
    "school": "ODISHA ADARSHA VIDYALAYA MASANIMUNDA KESINGA",
    "score": "48 / 60",
    "srank": 11
  },
  {
    "class": "9",
    "exam": "Asian Science Olympiad (ASO) 2025-26",
    "name": "swayam sudip sahoo",
    "orank": 125,
    "prize": "",
    "roll": "AS196806554",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "51 / 60",
    "srank": 8
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "chitranjali priyadarshini",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared), Olympiad Gold Medal ",
    "roll": "SS196806173",
    "school": "kendriya vidyalaya no1",
    "score": "58/60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Lipsa Acharya",
    "orank": 47,
    "prize": "Special Prize",
    "roll": "SS196806100",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "47/60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Md. Zisan",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "SS196806102",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "49/60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Ojas Samal",
    "orank": 8,
    "prize": "School Silver Medal + Special prize",
    "roll": "SS196806176",
    "school": "K.V. NO. 3 Bhubaneshwar, Odisha",
    "score": "54/60",
    "srank": 2
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Shubham Krishna ",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "SS196809200",
    "school": "Mount Litra Zee School",
    "score": "49/60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Soham Mishra",
    "orank": 1,
    "prize": "Cash award of Rs.2000/- (Prize shared), Olympiad Gold Medal ",
    "roll": "SS196809201",
    "school": "Mount Litra Zee School",
    "score": "58/60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Sonakshi Ojha",
    "orank": 19,
    "prize": "Special Prize",
    "roll": "SS196809202",
    "school": "Mount Litra Zee School",
    "score": "52/60",
    "srank": 4
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Sonakshi Sahoo",
    "orank": 25,
    "prize": "Special Prize",
    "roll": "SS196809203",
    "school": "Mount Litra Zee School",
    "score": "50/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Suhana Noor",
    "orank": 12,
    "prize": "School Bronze Medal + Special prize",
    "roll": "SS196809204",
    "school": "Mount Litra Zee School",
    "score": "53/60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Vanraj Mishra",
    "orank": 61,
    "prize": "",
    "roll": "SS196809205",
    "school": "Mount Litra Zee School",
    "score": "41/60",
    "srank": 8
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Vedanshi Sahoo",
    "orank": 36,
    "prize": "Special Prize",
    "roll": "SS196809206",
    "school": "Mount Litra Zee School",
    "score": "49/60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Vishal Kumar Biswas",
    "orank": 8,
    "prize": "School Silver Medal + Special prize",
    "roll": "SS196806172",
    "school": "Kendriya Vidyalaya no 1 ",
    "score": "54/60",
    "srank": 2
  },
  {
    "class": "9",
    "exam": "Asian Space Science Olympiad (ASSO) 2025-26",
    "name": "Yuvik Jayasingh",
    "orank": 72,
    "prize": "",
    "roll": "SS196809207",
    "school": "Mount Litra Zee School",
    "score": "40/60",
    "srank": 9
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "CHITRANJALI PRIYADARSHINI",
    "orank": 19,
    "prize": "Special Prize",
    "roll": "AT196806784",
    "school": "KENDRIYA VIDYALAYA NO 1 BHUBANESWAR",
    "score": "54/60",
    "srank": 4
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Md. Zisan",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AT196806360",
    "school": "Kendriya Vidyalaya no - 6",
    "score": "49/60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Ojas Samal",
    "orank": 15,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AT196806789",
    "school": "K.V.No.3 Bhubaneswar",
    "score": "55 / 60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Prilipsa Priyadarshini",
    "orank": "",
    "prize": "",
    "roll": "AT196809414",
    "school": "KENDRIYA VIDYALAYA NO-1 (2ND SHIFT ) BHUBANESWAR",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Rajdeep Jena",
    "orank": 68,
    "prize": "",
    "roll": "AT196806361",
    "school": "Kendriya Vidyalaya no - 5",
    "score": "39 / 60",
    "srank": 8
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Reehana Parinika",
    "orank": 1,
    "prize": "Cash award of Rs.3000/- (Prize shared) Olympiad Gold Medal ",
    "roll": "AT196809415",
    "school": "Mount Litra Zee School",
    "score": "60/60",
    "srank": 1
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Rishita Mishra",
    "orank": 8,
    "prize": "School Silver Medal + Special prize",
    "roll": "AT196809416",
    "school": "Lumbini Public School",
    "score": "57/60",
    "srank": 2
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Sai Subham Biswal",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AT196809214",
    "school": "DAV Unit - 8",
    "score": "49/60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Samikshya Swain",
    "orank": 39,
    "prize": "Special Prize",
    "roll": "AT196809417",
    "school": "Mount Litra Zee School",
    "score": "51/60",
    "srank": 6
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Samrata sahoo",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AT196806785",
    "school": "Kendriya Vidyalaya No-1",
    "score": "49/60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Sanchit Panda",
    "orank": 45,
    "prize": "Special Prize",
    "roll": "AT196809418",
    "school": "Cohen International",
    "score": "49/60",
    "srank": 7
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Shreyansh Prusty",
    "orank": "",
    "prize": "",
    "roll": "AT196809419",
    "school": "Kendriya vidyalaya no 13",
    "score": "Absent",
    "srank": ""
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Shreyanshi Sahu",
    "orank": 15,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AT196806787",
    "school": "Mount Litra Zee School",
    "score": "55/60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Shriyans Kar",
    "orank": 15,
    "prize": "School Bronze Medal + Special prize",
    "roll": "AT196809420",
    "school": "Mount Litra Zee School",
    "score": "55/60",
    "srank": 3
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "Shriyashree Mohanty",
    "orank": 24,
    "prize": "Special Prize",
    "roll": "AT196809421",
    "school": "Mount Litra Zee School",
    "score": "53/60",
    "srank": 5
  },
  {
    "class": "9",
    "exam": "Asian Talent Hunt  Olympiad (ATHO) 2025-26",
    "name": "SWAYAM SUDIP SAHOO",
    "orank": 24,
    "prize": "Special Prize",
    "roll": "AT196806782",
    "school": "Kendriya vidyalaya no 1 bbsr",
    "score": "53/60",
    "srank": 5
  }
]

export default function queryData(roll) {
  if (roll === "" || roll === "") {
    return "Please enter a valid roll number";
  }
  const result = data.find((d) => d.roll === roll)
    ? data.find((d) => d.roll === roll)
    : `No certificate found for ${roll}`;
  return result;
}
